{
  "Common": {
    "Youtopia": "Youtopia",
    "Invalid_Phone_Number": "Please enter a valid phone number.",
    "Partner": "Healthy Gourmet Kitchen",
    "Cancel": "Cancel",
    "Save": "Save",
    "Saved": "Saved",
    "Apply": "Apply",
    "Confirm": "Confirm",
    "Delete": "Delete",
    "Continue": "Continue",
    "Back": "Back",
    "Finish": "Finish",
    "Pay": "Pay",
    "Skip": "Skip",
    "Next": "Next",
    "Add": "Add",
    "Remove": "Remove",
    "Reset_Changes": "Reset Changes",
    "Save_Changes": "Save Changes",
    "Create_New_Version": "Create New Version",
    "Save_New_Version": "Save New Version",
    "Search": "Search",
    "Select_New_Target_Customers": "Select new target customers",
    "Recipe": "Recipe",
    "Ingredient": "Ingredient",
    "Something_Went_Wrong": "Something Went Wrong",
    "Done": "Done",
    "Get_Started": "Get Started",
    "Launch": "Launch",
    "Edit": "Edit",
    "Manage": "Manage",
    "Add_Photo": "Add Photo",
    "Upload_Photo": "Upload Photo",
    "Actions": "Actions",
    "None": "None",
    "Review": "Review",
    "Go_To_Home": "Go To Home",
    "Page_Not_Found": "Page Not Found",
    "Youtopia_Partners": "Youtopia Partners",
    "No_Results": "No Results",
    "Opens_At": "Opens At",
    "Closes_At": "Closes At",
    "Closed": "Closed"
  },
  "Navigation": {
    "Dashboard": "Dashboard",
    "My_Menu": "My Menu",
    "Orders": "Orders",
    "Producer_Profile": "Kitchen Profile"
  },
  "Landing": {
    "Log_In": "Log In",
    "Sign_Up": "Sign Up",
    "Join_Us_In_Changing": "Join us in changing the way the world eats!",
    "Hero_Title": "Build steady kitchen volume with automated precision nourishment",
    "Hero_Subtitle": "Youtopia helps kitchens plan earlier, run steadier, and earn more using automated precision nourishment.",
    "Learn_About_Producer": "Learn about Healthy Gourmet Kitchens",
    "List_Your_Food_On_Our_Platform": "List your food on our platform for Youtopians to enjoy!",
    "Upload_Your_Recipes": "Upload your recipes",
    "Optimize_Your_Meal": "Optimize your meal",
    "Manage_Your_Inventory": "Manage your inventory",
    "Frequently_Asked_Questions": "Frequently Asked Questions",
    "FAQ1_Title": "What is the process to create an account on the platform?",
    "FAQ1_Description": "To create an account, click on the \"Sign Up\" button on the homepage. Fill in the required details, including your name, email address, and business information. After submitting the form, you'll receive a confirmation email. Click the link in the email to activate your account.",
    "FAQ2_Title": "How do I upload or create consumables on the platform?",
    "FAQ3_Title": "What does it mean to have my consumables analyzed?",
    "FAQ4_Title": "Why would I optimize my food?",
    "FAQ5_Title": "What is Youtopia Certification, and how do I get my consumables certified?",
    "FAQ6_Title": "What are the benefits of having Youtopia Certified consumables?",
    "FAQ7_Title": "How do I manage my consumables on the platform?",
    "FAQ8_Title": "Can I add marketing materials for my consumables?",
    "Signup": {
      "Title": "Welcome! Let's get your kitchen on Youtopia",
      "Description": "We're excited to work with you. Let's start with the basics.",
      "Email": "Email",
      "Password": "Password"
    }
  },
  "Onboarding": {
    "Result": {
      "Match_Title": "Looks like we're a great match!",
      "Match_Description": "Based on what you've shared, here's how your kitchen operates today—and where we can work together to make things steadier, more predictable, and more rewarding:",
      "Match_Benefits_Title": "Let's make your kitchen more rewarding to run.",
      "Match_Benefits_Subtitle": "Here's how we'll do it—together:",
      "Match_Benefit_1": "Predictable demand so you can plan with confidence",
      "Match_Benefit_2": "Higher margins through greater utilization of existing overhead",
      "Match_Benefit_3": "Fuller schedules, fewer idle hours, and better team morale",
      "Button_Text": "Continue",
      "NoMatch_Title": "Sorry, but it looks like we are not a great match",
      "NoMatch_Description": "We hope we have the opportunity to work together in the future. Please stay connected and watch for updates at youtopia.com"
    },
    "Exit": {
      "Title": "We're not quite ready for you yet",
      "Description": "You've built something worth partnering with. We just need a little more time to grow into it. Sign up to hear from us when that changes.",
      "Button_Text": "Explore Youtopia"
    },
    "AreaCheck": {
      "Title": "Are we in your area?",
      "Description": "Enter your kitchen address to check if we cover pickup and delivery in your city.",
      "Address_Label": "Address",
      "Address2_Label": "Address Line 2 (Apt, Suite, etc.)",
      "City_Label": "City",
      "State_Label": "State",
      "Zip_Label": "Zip Code",
      "Button_Text": "Continue",
      "InArea_Title": "Good news! We're in your area.",
      "InArea_Description": "You're in the right place. Let's take a few minutes to make sure Youtopia is the right fit for your kitchen.",
      "NotInArea_Title": "We're not in your area yet",
      "NotInArea_Description": "Youtopia isn't in your area yet — but we've added your spot and we'll let you know the moment that changes.",
      "NotInArea_Callout_Title": "On the list",
      "NotInArea_Callout_Subtitle": "We'll send a heads-up when Youtopia reaches your area.",
      "NotInArea_Primary": "Keep me posted",
      "Upvoted": "You've upvoted",
      "Upvoted_Saved": "We've saved your request and will notify you as soon as Youtopia launches in your area.",
      "Keep_Me_Notified": "Keep me notified",
      "No_Thanks": "No thanks",
      "No_Results": "No results"
    },
    "Account": {
      "Title": "Welcome! Let's start with the basics",
      "Description": "Welcome to the revolutionary new world of automated precision nourishment. Now your business can incorporate pre-sold demand, keep more margin, reduce food waste, and develop your team while reducing turnover — all while building a highly respected brand that brings your customers back again and again.",
      "First_Name": "First Name",
      "Last_Name": "Last Name",
      "POC_First_Name": "Point of contact first name",
      "POC_Last_Name": "Point of contact last name",
      "Phone_Number": "Phone number",
      "Email": "Email",
      "Business_Name": "Business Name",
      "Business_Location": "Business Location",
      "Business_Address": "Business Address",
      "Address_Two": "Address 2",
      "Business_Email": "Business Email",
      "Business_Phone": "Business Phone",
      "Button_Text": "Create Account",
      "Update": "Update",
      "Position": "What's your position?",
      "Business_Types": "Business type(s)",
      "Secondary_Email": "Secondary Email (Optional)",
      "Secondary_Phone": "Secondary Phone (Optional)",
      "Consent": "I agree to the Terms of Service and Privacy Policy"
    },
    "First_Name": "First Name",
    "Last_Name": "Last Name",
    "Email": "Email",
    "Business_Location": "Business Location",
    "Business_Name": "Business Name",
    "Business_Email": "Business Email",
    "Business_Phone": "Business Phone",
    "Registration_Failed": "Registration Failed",
    "Registration_Success": "Registration Successful, Redirecting to Login",
    "Step_1": {
      "Title": "Let's learn a little bit about you",
      "Description": "Your answers help us understand whether we can support your operations properly.",
      "Insight_Title": "Meals predictable. Finally.",
      "Context": "Our schedule and save automation allows us to provide operators with consolidated orders at a minimum of 2 days in advance.",
      "Question_Label": "How many additional meals can your kitchen produce and store chilled each day using off peak hours?",
      "Option_0": "0-19 meals",
      "Option_1": "20 - 50 meals",
      "Option_2": "51-100 meals",
      "Option_3": "100+ meals",
      "Option_4": "200+ meals",
      "Button_Text": "Continue"
    },
    "Step_2": {
      "Title": "Great — that's helpful to know",
      "Description": "Understanding how your kitchen operates helps us plan how Schedule Ahead & Save orders could fit into your workflow.",
      "Insight_Title": "Reputation matters",
      "Context": "Its important to Youtopia to partner with reputable and experienced food service kitchens.",
      "Question_Label": "What is your current Google or Yelp rating?",
      "Option_1": "4.5+",
      "Option_2": "4.0–4.4",
      "Option_3": "Below 4.0",
      "Option_4": "Not listed",
      "Button_Text": "Continue"
    },
    "Step_3": {
      "Title": "Quality starts with ingredients",
      "Description": "We work with kitchens who share our commitment to clean, quality food. So this one matters to us.",
      "Insight_Title": "We help you use the safest ingredients",
      "Context": "We work side by side with kitchens to review ingredient lists and find clean, approved swaps wherever needed.",
      "Question_Label": "How open is your kitchen to swapping certain ingredients for cleaner alternatives?",
      "Option_1": "We already cook clean",
      "Option_2": "A few small swaps, no problem",
      "Option_3": "It would take some work",
      "Option_4": "Not something we can do right now",
      "Button_Text": "Continue"
    },
    "Step_Q4": {
      "Title": "That's great to hear.",
      "Description": "Youtopia works closely with kitchens, so it's helpful for us to understand how teams approach ingredients and preparation.",
      "Insight_Title": "We've been in your shoes",
      "Context": "Cooking delicious and healthy can be a new experience. Because we've successfully run our own restaurants we have learnt a few tricks along the way that we are happy to share, if desired.",
      "Question_Label": "How ready is your team to learn new preparation methods they may not be familiar with today?",
      "Option_1": "Ready now",
      "Option_2": "Open, with training",
      "Option_3": "Unsure",
      "Option_4": "Not a priority",
      "Button_Text": "Continue"
    },
    "Step_Q5": {
      "Title": "Just one last thing.",
      "Description": "This final question helps us understand how Youtopia meals could fit into your existing menu.",
      "Insight_Title": "Bringing customers into your restaurant",
      "Context": "Youtopian consumers like to eat out at restaurants in addition to having meals delivered.",
      "Question_Label": "Matching your cuisine, restaurant style and brand, how many Youtopia-certified meals could you add to your menu?",
      "Option_1": "5–7 items",
      "Option_2": "8–12 items",
      "Option_3": "Would require meaningful changes",
      "Option_4": "Not currently possible",
      "Button_Text": "Continue"
    },
    "Step_4": {
      "Headline": "Build Schedules with Confidence—Less Guessing, More Clarity",
      "Subheadline": "When orders are sold in advance, it’s easier to see what’s ahead—who to schedule, when to prep, and how to keep the team steady without the usual stress.",
      "Card1_Title": "Pre-Sold Orders",
      "Card1_Body": "Know what’s coming before the week begins.",
      "Card2_Title": "Fewer Idle Shifts",
      "Card2_Body": "Reduce time spent waiting for walk-ins or last-minute orders.",
      "Card3_Title": "Lower Turnover",
      "Card3_Body": "Predictable shifts help teams stick around.",
      "Card4_Title": "Better Morale",
      "Card4_Body": "Clear plans make it easier for everyone to show up ready.",
      "Bottomline": "Structure brings calm. Pre-sold demand gives us the clarity to build smoother schedules and reduce stress—without the guesswork.",
      "Button_Text": "Next Up: Predictable Demand"
    },
    "Step_5": {
      "Quote": "Getting a prediction wrong can mean understaffed shifts, wasted food, frustrated customers, bad reviews, and lost revenue.",
      "Attribution": "NetSuite. “Restaurant Forecasting: How to Forecast Restaurant Sales.” NetSuite, Oracle.",
      "Description_Line_1": "When plans come together at the last minute, shifts can feel reactive—more scrambling than steady.",
      "Description_Line_2": "But knowing what’s sold days in advance can change that—bringing calm, clarity, and fewer surprises.",
      "Button_Text": "Let's talk about your predictability"
    },
    "Step_6": {
      "Title": "Let's talk about predictability in your operation.",
      "Subtitle": "A few quick questions to understand how far ahead you can see demand—and what might help.",
      "Question_1": "How far in advance do you typically know what you'll be producing?",
      "Question_1_Option_1": "Same day",
      "Question_1_Option_2": "1 day in advance",
      "Question_1_Option_3": "2–3 days in advance",
      "Question_1_Option_4": "4+ days in advance",
      "Question_2": "How often does late or last-minute demand affect your team or prep?",
      "Question_2_Option_1": "Constantly",
      "Question_2_Option_2": "Often",
      "Question_2_Option_3": "Sometimes",
      "Question_2_Option_4": "Rarely",
      "Question_2_Option_5": "Never",
      "Question_3": "What would change for you if most of your orders were sold 3+ days ahead?",
      "Question_3_Option_1": "We'd prep more efficiently",
      "Question_3_Option_2": "We'd schedule better",
      "Question_3_Option_3": "We'd reduce waste and stress",
      "Question_3_Option_4": "All of the above",
      "Question_3_Option_5": "Not sure",
      "Button_Text": "Continue"
    },
    "Step_7": {
      "Headline": "Plan Ahead with Confidence",
      "Subheadline": "Seeing demand earlier makes it easier to prep with purpose, staff with intention, and avoid last-minute surprises.",
      "Card1_Title": "Clearer Demand Visibility",
      "Card1_Body": "Know what’s coming before the week begins.",
      "Card2_Title": "Reduced Day-of Chaos",
      "Card2_Body": "Fewer surprises mean calmer kitchens.",
      "Card3_Title": "More Confident Planning",
      "Card3_Body": "Make staffing and purchasing decisions with clarity.",
      "Card4_Title": "Stronger Operational Rhythm",
      "Card4_Body": "Shift from reactive to proactive, one week at a time.",
      "Bottomline": "We can’t control every order—but more visibility means more control over the week.",
      "Button_Text": "Next Up: Kitchen Utilization"
    },
    "Step_8": {
      "Quote": "Utilization below 65% signals that your space and team are not being fully used—and that you might be leaving profit on the table.",
      "Attribution": "“What is a Utilization Report?” Saviom, Jul 10 2025",
      "Description_Line_1": "We already invest in our kitchens and our teams—so it’s worth exploring how to make the most of that time and space.",
      "Description_Line_2": "With more predictable orders, slower hours can become productive ones—without adding pressure or stretching the team thin.",
      "Button_Text": "Let's talk about Kitchen Utilization"
    },
    "Step_9": {
      "Title": "Let's take a closer look at kitchen utilization",
      "Description": "A few quick questions to see how your space is used—and where there might be untapped potential.",
      "Question_1": "How many hours per day is your kitchen actively producing food?",
      "Question_1_Option_1": "Less than 4",
      "Question_1_Option_2": "4–8 hours",
      "Question_1_Option_3": "9–12 hours",
      "Question_1_Option_4": "More than 12 hours",
      "Question_2": "Are there consistent blocks of time where the kitchen sits idle?",
      "Question_2_Option_1": "Yes—mornings",
      "Question_2_Option_2": "Yes—afternoons",
      "Question_2_Option_3": "Yes—late nights",
      "Question_2_Option_4": "No—we're usually in use",
      "Question_3": "If demand was guaranteed, would you be willing to prep or cook outside your current hours?",
      "Question_3_Option_1": "Yes—absolutely",
      "Question_3_Option_2": "Maybe—for the right volume",
      "Question_3_Option_3": "Probably not",
      "Question_3_Option_4": "Not sure",
      "Button_Text": "Continue"
    },
    "Step_10": {
      "Headline": "Make Every Hour Count",
      "Subheadline": "Every hour has value. By using quieter times for pre-sold orders, we can keep kitchens active and teams engaged—without adding extra strain.",
      "Card1_Title": "Pre-Planned Production Blocks",
      "Card1_Body": "Use early mornings, late nights, or off-peak hours to meet steady demand.",
      "Card2_Title": "Better Use of Space & Equipment",
      "Card2_Body": "Get more out of what’s already in place.",
      "Card3_Title": "Flexible Production Windows",
      "Card3_Body": "Cook when it fits your flow, not just rush hours.",
      "Card4_Title": "Steady, Scalable Scheduling",
      "Card4_Body": "Build predictable routines—day by day, week by week.",
      "Bottomline": "When we know what’s ahead, we can plan with confidence and use our time in ways that work better for everyone.",
      "Button_Text": "Next Up: Cutting Food Waste"
    },
    "Step_11": {
      "Quote": "Restaurants waste an estimated 4–10% of the food they purchase, largely due to overproduction and unpredictable customer demand.",
      "Attribution": "ReFED. “Restaurant Food Waste Action Guide.” ReFED, 2022",
      "Description_Line_1": "When demand is unpredictable, waste can feel unavoidable.",
      "Description_Line_2": "But with more visibility, we can prep with precision—buying only what’s needed and putting it all to use.",
      "Button_Text": "Let's take a look at your food waste"
    },
    "Step_12": {
      "Title": "Let's take a look at food waste and purchasing.",
      "Description": "A few quick questions to see where waste happens and how demand clarity could help.",
      "Question_1_Label": "Roughly what percentage of your food gets wasted or thrown out each week?",
      "Question_1_Option_1": "Less than 5%",
      "Question_1_Option_2": "5–10%",
      "Question_1_Option_3": "11–15%",
      "Question_1_Option_4": "More than 15%",
      "Question_1_Option_5": "I'm not sure",
      "Question_2_Label": "Where does most of your food waste come from?",
      "Question_2_Option_1": "Over-prepping for unknown demand",
      "Question_2_Option_2": "Buying too much",
      "Question_2_Option_3": "Cancellations or no-shows",
      "Question_2_Option_4": "Spoilage from poor rotation",
      "Question_2_Option_5": "Not sure",
      "Question_3_Label": "How do you currently forecast how much to prep or order?",
      "Question_3_Option_1": "Gut instinct",
      "Question_3_Option_2": "Last week's numbers",
      "Question_3_Option_3": "Daily sales trends",
      "Question_3_Option_4": "Pre-orders",
      "Question_3_Option_5": "We don't really forecast",
      "Button_Text": "Continue"
    },
    "Step_13": {
      "Headline": "Make the Most of Every Ingredient",
      "Subheadline": "When we know what’s already sold, it’s easier to prep just what’s needed—reducing waste and making every dollar go further.",
      "Card1_Title": "Predictable Volume",
      "Card1_Body": "Plan purchasing and prep around confirmed demand.",
      "Card2_Title": "Less Waste, More Profit",
      "Card2_Body": "Avoid overbuying and cut down on spoilage.",
      "Card3_Title": "Smarter Ordering",
      "Card3_Body": "Buy what’s needed, when it’s needed—with clarity, not pressure.",
      "Card4_Title": "Sustainable Operations",
      "Card4_Body": "Use less, waste less, and feel good doing it.",
      "Bottomline": "When prep matches demand, nothing goes to waste.",
      "Button_Text": "Next Up: Higher Margins Without Third Party Fees"
    },
    "Step_14": {
      "Quote": "Delivery fees for third-party apps can range from 15 to 30%, significantly reducing restaurant profit margins.",
      "Attribution": "— National Restaurant Association. “State of the Restaurant Industry Report 2024.”",
      "Description_Line_1": "Delivery platforms can help reach customers—but their fees often take a big share, even after all the prep, cooking, and staffing.",
      "Description_Line_2": "We’re exploring a simpler model that keeps more margin in the hands of those doing the work.",
      "Button_Text": "Let's talk about delivery platforms"
    },
    "Step_15": {
      "Title": "Let's talk about the fees you're paying now.",
      "Question_1_Label": "Which third-party delivery platforms do you currently use?",
      "Question_1_Option_1": "Doordash",
      "Question_1_Option_2": "Grubhub",
      "Question_1_Option_3": "Uber Eats",
      "Question_1_Option_4": "Other",
      "Question_2_Label": "Roughly what percentage of your order revenue goes to platform fees?",
      "Question_2_Option_1": "Less than 15%",
      "Question_2_Option_2": "15–20%",
      "Question_2_Option_3": "21–30%",
      "Question_2_Option_4": "More than 30%",
      "Question_2_Option_5": "Not sure",
      "Question_3_Label": "Which of these best describes how you feel about those fees?",
      "Question_3_Option_1": "They're just part of doing business",
      "Question_3_Option_2": "They're frustrating, but we rely on them",
      "Question_3_Option_3": "They're unsustainable and eating our margins",
      "Question_3_Option_4": "We're actively looking for a better alternative",
      "Button_Text": "Continue"
    },
    "Step_16": {
      "Headline": "Fairer Fees. Clearer Margins. A Model That Respects the Work.",
      "Subheadline": "Our approach is designed to keep more profit where it belongs—supporting the kitchens and teams doing the work.",
      "Card1_Title": "Transparent Pricing",
      "Card1_Body": "Simple, upfront, with no hidden fees.",
      "Card2_Title": "Keep More Per Order",
      "Card2_Body": "More margin stays in your hands.",
      "Card3_Title": "Chef-First Model",
      "Card3_Body": "The focus stays on your food and your team—not the platform.",
      "Card4_Title": "Support That Works With You",
      "Card4_Body": "We partner alongside you, not against you.",
      "Bottomline": "Good food should support good business—without extra layers cutting into the margin.",
      "Button_Text": "Next Up: Maximizing Return on Overhead"
    },
    "Step_17": {
      "Quote": "Labor and occupancy costs continue to rise, but without a proportional increase in sales, many restaurants are operating on thinner margins than ever before.",
      "Attribution": "— National Restaurant Association. “2024 State of the Restaurant Industry Report.”",
      "Description_Line_1": "Overhead is part of running a kitchen—but when space or teams sit idle, it can weigh heavier on the bottom line.",
      "Description_Line_2": "With more predictable demand, we can put that time and space to better use—without adding extra hours or cost.",
      "Button_Text": "Let's talk about your overhead"
    },
    "Step_18": {
      "Title": "Let's talk about overhead and return.",
      "Question_1_Label": "What's your biggest fixed monthly cost outside of labor?",
      "Question_1_Option_1": "Rent or lease",
      "Question_1_Option_2": "Utilities",
      "Question_1_Option_3": "Equipment",
      "Question_1_Option_4": "Maintenance",
      "Question_1_Option_5": "Other",
      "Question_2_Label": "Do you feel your space and team are being used to their full potential?",
      "Question_2_Option_1": "No, there's a lot of underutilized time",
      "Question_2_Option_2": "Somewhat, but we could be doing more",
      "Question_2_Option_3": "Yes, we're running close to max capacity",
      "Question_2_Option_4": "I'm not sure",
      "Question_3_Label": "What would help you make better use of your current overhead?",
      "Question_3_Option_1": "More predictable demand",
      "Question_3_Option_2": "A way to spread production across more hours",
      "Question_3_Option_3": "A higher return per shift",
      "Question_3_Option_4": "All of the above",
      "Button_Text": "Continue"
    },
    "Step_19": {
      "Headline": "Make the Most of What We Already Have",
      "Subheadline": "We’ve invested in our teams, spaces, and tools. With more predictability, those investments can go further—without extra hours or added cost.",
      "Card1_Title": "Fill More Gaps, Not Just Peak Hours",
      "Card1_Body": "Use quiet shifts to meet steady demand.",
      "Card2_Title": "Get More from Every Shift",
      "Card2_Body": "Every hour and every space has value to offer.",
      "Card3_Title": "Stretch Costs Across More Revenue",
      "Card3_Body": "Spread fixed costs over more production.",
      "Card4_Title": "No Extra Labor or Equipment Needed",
      "Card4_Body": "It’s about using what’s in place, more intentionally.",
      "Bottomline": "We’re not here to squeeze more out—we’re here to make things smoother, steadier, and more sustainable.",
      "Button_Text": "Next Up: Final Details"
    },
    "Step_20": {
      "Title": "Let's wrap up with some details about your operation.",
      "Business_Type_Label": "Which option best describes your business?",
      "Business_Type_Option1": "Brick and Mortar Restaurant",
      "Business_Type_Option2": "Ghost Kitchen",
      "Business_Type_Option3": "Pre-packaged Manufacturer",
      "Business_Type_Option4": "Personal Chef",
      "Business_Type_Option5": "Catering",
      "Cuisine_Label": "What best describes your cuisine focus?",
      "Role_Label": "Which option best describes your role?",
      "Role_Option1": "Head Chef",
      "Role_Option2": "Sous Chef",
      "Role_Option3": "Business Owner",
      "Role_Option4": "Other",
      "Head_Chef_Label": "Who is your head chef?",
      "Head_Chef_Description": "Customers on Youtopia will be able to leave feedback on the Head Chef's meal item regarding taste, presentation, and overall quality.",
      "First_Name": "FIRST NAME",
      "Last_Name": "LAST NAME",
      "Email": "EMAIL ADDRESS",
      "Button_Text": "Continue"
    },
    "Step_21": {
      "Headline": "Looks like we’re a great fit.",
      "Subheadline": "Based on what you’ve shared, here’s how your kitchen operates today—and where we can work together to make things steadier, more predictable, and more rewarding.",
      "Snapshot_Title": "Your Operation Snapshot",
      "Button_Text": "Create an Account and Learn More",
      "Benefits_Title": "Let's make your kitchen more rewarding to run.",
      "Benefits_Subtitle": "Here's how we'll do it—together:",
      "Benefits_Item_1": "Predictable weekly demand so you can plan with confidence",
      "Benefits_Item_2": "Higher margins by keeping more profit from every order",
      "Benefits_Item_3": "Fuller schedules, fewer idle hours, and better team morale"
    },
    "Step_22": {
      "Headline": "Create your account",
      "Email_Label": "Primary user's business email address",
      "Password_Label": "Password",
      "Confirm_Password_Label": "Confirm password",
      "Back_Button": "Back",
      "Submit_Button": "Create Account"
    },
    "Summary_Group_Capacity": "Capacity & Reputation",
    "Summary_Group_Quality": "Quality & Team Readiness",
    "Summary_Group_Business": "Business Info",
    "Passwords_Do_Not_Match": "Passwords Do Not Match",
    "Pick_A_Password": "Pick a password",
    "At_Least_One_Uppercase": "At least one uppercase",
    "At_Least_One_Lowercase": "At least one lowercase",
    "At_Least_One_Number": "At least one numeric",
    "At_Least_One_Special": "At Least One Of !@#$%^&*",
    "Minimum_Length": "Minimum 8 characters",
    "Submit": "Submit",
    "Create_Failed": "We couldn't create your producer account. Please try again.",
    "Save_Failed": "We couldn't save your answer. Please try again.",
    "Submit_Failed": "We couldn't submit your application. Please try again.",
    "Incomplete_Submission": "Your application is missing an answer or your consent to the terms. Please review and try again.",
    "Close": {
      "NotYet_Title": "We'd love to stay in touch.",
      "NotYet_Description": "No judgment from a form. Things change, and so will Youtopia. We'll let you know as we grow.",
      "NotYet_Callout_Title": "On the list",
      "NotYet_Callout_Subtitle": "We'll send a heads-up when Youtopia opens near you — and again as things expand.",
      "NotYet_Primary": "Keep me posted",
      "NotYet_Secondary": "No thanks"
    },
    "ValueProp": {
      "Title": "Here's what your kitchen looks like with Youtopia.",
      "Intro": "Partnering with us means:",
      "Callout_Title": "Let's make your kitchen more rewarding to run.",
      "Callout_Subtitle": "Here is how we do it together:",
      "Benefit_1": "Predictable demand so you can plan with confidence",
      "Benefit_2": "Higher margins by making the most of your existing capacity",
      "Benefit_3": "Fuller schedules, fewer idle hours, and better team morale",
      "Primary": "Yes! Let's set up my kitchen",
      "Secondary": "Not yet, keep me posted"
    },
    "Q": {
      "Capacity": {
        "Title": "Your kitchen's capacity",
        "Description": "Tell us about your production volume.",
        "Average_Label": "How many meals do you produce on an average day?",
        "Best_Label": "And on your best day of the year?"
      },
      "Presold": {
        "Title": "Pre-sold capacity",
        "Description": "If most orders were pre-sold, how much more could you make?",
        "Label": "Additional meals per day you could produce and chill if the majority were pre-sold",
        "Callout": "Pre-selling 3–10 days out gives you time to plan, prep, and keep your team productive while minimizing waste."
      },
      "Rating": {
        "Title": "Your reputation",
        "Description": "Your current reviews and your appetite to grow.",
        "Rating_Label": "What's your current Google or Yelp rating?",
        "Impact_Label": "How willing are you to let planning improve your results?"
      },
      "CleanIngredients": {
        "Title": "Clean ingredients",
        "Description": "Youtopia Certified items use clean ingredients.",
        "Label": "How ready are you to embrace clean ingredients for Youtopia Certified items?"
      },
      "CertifiedItems": {
        "Title": "Certified menu items",
        "Description": "Carrying a set of Youtopia Certified items.",
        "Label": "How comfortable are you carrying 8–12 Youtopia Certified items?"
      },
      "TeamImpact": {
        "Title": "Impact on your team",
        "Description": "Select all that apply.",
        "Label": "How would running at full pre-sold capacity impact your team?"
      },
      "CommissionSavings": {
        "Title": "Commission savings",
        "Description": "Select all that apply.",
        "Label": "How would commission savings help your business?",
        "Callout": "Delivery apps charge 20–35% commission — keep that margin and reinvest it in your business."
      },
      "Readiness": {
        "Title": "Ready to join?",
        "Description": " ",
        "Label": "How ready are you to become a Youtopia Healthy Gourmet Kitchen?"
      }
    },
    "Options": {
      "MealsPerDayAverage": {
        "Range0To50": "0–50",
        "Range50To100": "50–100",
        "Range100To150": "100–150",
        "Range150To200": "150–200",
        "Over200": "Over 200"
      },
      "MealsPerDayBest": {
        "Range150To200": "150–200",
        "Range200To250": "200–250",
        "Range250To300": "250–300",
        "Range300To400": "300–400",
        "Over400": "Over 400"
      },
      "AdditionalPresoldCapacity": {
        "UpTo100": "Up to 100",
        "Range100To200": "100–200",
        "Range200To300": "200–300",
        "Range300To400": "300–400",
        "Over400": "Over 400"
      },
      "GoogleYelpRating": {
        "FourFiveOrHigher": "4.5 or higher",
        "FourZeroToFourFour": "4.0–4.4",
        "BelowFourZero": "Below 4.0",
        "NotListed": "Not listed"
      },
      "RatingImpactWillingness": {
        "GreatlyEnhance": "It would greatly enhance my results",
        "StayAboutTheSame": "It would stay about the same"
      },
      "CleanIngredientsWillingness": {
        "AlreadyCookThisWay": "We already cook this way",
        "FewSmallSwaps": "A few small swaps",
        "OpenWithWork": "Open to it with some work",
        "NotRightNow": "Not right now"
      },
      "CertifiedItemCountComfort": {
        "EightToTwelveFeelsRight": "8–12 feels right",
        "CouldDoMoreThanTwelve": "We could do more than 12",
        "TooMany": "That feels like too many",
        "NotSure": "Not sure yet"
      },
      "TeamImpactOption": {
        "ReliablePredictableWorkloads": "Reliable, predictable workloads",
        "GrowTopProfessionals": "Grow top professionals",
        "LessStressMoreFun": "Less stress, more fun",
        "QualityOfLifeImproves": "Quality of life improves",
        "PrideInPositiveImpact": "Pride in a positive impact"
      },
      "CommissionSavings": {
        "GenerateMorePresoldOrders": "Generate more pre-sold orders",
        "PassRatesToCustomers": "Pass savings on to customers",
        "BuildLocalBrand": "Build our local brand",
        "DriveDineInVolume": "Drive dine-in volume",
        "FinancialSuccessAndTeamPride": "Financial success and team pride",
        "EnhanceCommunityHealth": "Enhance community health"
      },
      "OnboardingReadiness": {
        "Absolutely": "Absolutely",
        "HighlyLikely": "Highly likely",
        "NotSure": "Not sure yet",
        "No": "No, not right now"
      },
      "BusinessType": {
        "BrickAndMortarRestaurant": "Brick & mortar restaurant",
        "GhostKitchen": "Ghost kitchen",
        "PrePackagedManufacturer": "Pre-packaged manufacturer",
        "PersonalChef": "Personal chef",
        "Catering": "Catering"
      },
      "BusinessRole": {
        "Head_Chef": "Head chef",
        "Sous_Chef": "Sous chef",
        "Business_Owner": "Business owner",
        "Other": "Other"
      }
    },
    "Review": {
      "Title": "Create your account",
      "Description": "We'll use this to connect your kitchen, menu, and payouts.",
      "Create_Account": "Create Account"
    }
  },
  "Onboarding_Learning": {
    "Step_0": {
      "Page_1_Title": "You're in good company.",
      "Page_1_Intro": "We've run kitchens through slow winters, rushes that stretch your team thin, and weeks where demand is anyone's guess. We know the work it takes to keep going.",
      "Page_1_List_Intro": "Most kitchens we know want the same things:",
      "Page_1_List_Item_1": "Steady, predictable demand that fills slow periods",
      "Page_1_List_Item_2": "Customers who choose you for quality, not just price",
      "Page_1_List_Item_3": "Less time spent chasing orders and juggling uncertainty",
      "Page_1_Impact_Statement": "Now imagine meeting those needs while also giving your community something most people never get —",
      "Page_1_Impact_Highlight": "meals that genuinely make them healthier.",
      "Page_1_Subtitle": "Our north star is simple:",
      "Page_1_Statement": "If people are healthier 90 days from now, we're doing our job.",
      "Page_1_Closing": "At Youtopia we believe the best way to get there is by backing the people already doing the real work—you.",
      "Page_1_Sidebar_Title": "Did you know?",
      "Page_1_Sidebar_Stat_1": "93%",
      "Page_1_Sidebar_Desc_1": "of people have metabolic disease",
      "Page_1_Sidebar_Stat_2": "48%",
      "Page_1_Sidebar_Desc_2": "suffer from heart disease & strokes",
      "Page_1_Sidebar_Stat_3": "44%",
      "Page_1_Sidebar_Desc_3": "have diabetes or are pre-diabetic",
      "Page_1_Sidebar_Stat_4": "39%",
      "Page_1_Sidebar_Desc_4": "will have cancer",
      "Page_1_Sidebar_Stat_5": "75%",
      "Page_1_Sidebar_Desc_5": "are overweight",
      "Page_1_Sidebar_Text": "These are neighbors, families, and regulars at your tables. Every meal you make with care chips away at that problem.",
      "Page_2_Title": "How We Work Together",
      "Page_2_Subtitle_1": "You're not the problem — the Profit-Leak System is.",
      "Page_2_Paragraph_1": "Idle stations, unpredictable weeks, and outside skims drain profit from even the best kitchens. But you don't have to take that on alone. We've been there, and we've built a way to close those leaks together.",
      "Page_2_Subtitle_2": "Here's what this means for you:",
      "Page_2_Paragraph_2": "When we split the load, your week runs smoother — and your meals reach more of the people who'll appreciate them most.",
      "Page_2_Left_Title": "What You Handle",
      "Page_2_Left_Item_1": "Your craft and care",
      "Page_2_Left_Item_2": "Certified, high-quality ingredients",
      "Page_2_Left_Item_3": "Consistent, well-presented meals",
      "Page_2_Left_Item_4": "Your unique flavors and style",
      "Page_2_Right_Title": "What We Handle",
      "Page_2_Right_Item_1": "Ingredient standards you can trust",
      "Page_2_Right_Item_2": "Tools to match your meals with the right customers",
      "Page_2_Right_Item_3": "Steady, predictable demand",
      "Page_2_Right_Item_4": "Operational support from order to delivery",
      "Page_2_Closing": "Together, every meal counts—for your business and your community.",
      "Page_2_Sidebar_Title": "Did you know?",
      "Page_2_Sidebar_Stat_1": "51%",
      "Page_2_Sidebar_Desc_1": "of Denver residents reported eating out less than before, squeezing restaurant demand during slow periods.",
      "Page_2_Sidebar_Text": "- Kreie, Mark. \"Why are so many Denver restaurants going belly up or moving out of the city?\" Denver7 News. 25 Jan. 2024.",
      "Page_3_Title": "How the Youtopia Process Works",
      "Page_3_Paragraph_1": "We've already talked about the profit leaks that pull time and money out of your week.",
      "Page_3_Paragraph_2": "Here's how we bring it all together — while growing your impact.",
      "Page_3_Step_1_Title": "Plan",
      "Page_3_Step_1_Description": "See upcoming orders and ingredient needs in advance, so slow periods don't catch you off guard.",
      "Page_3_Step_2_Title": "Fulfill",
      "Page_3_Step_2_Description": "Prepare and package meals matched to the right customers, without extra guesswork.",
      "Page_3_Step_3_Title": "Learn",
      "Page_3_Step_3_Description": "Each order makes the system smarter, boosting future demand for your meals.",
      "Page_3_Summary": "More predictability. More of the right orders. Less wasted effort.",
      "Page_3_Closing": "You bring the craft, care, and ingredients. We bring the tools, automation, and customers who need what you make. Together, the cycle keeps growing — and so does your impact.",
      "Page_3_Sidebar_Title": "Did you know?",
      "Page_3_Sidebar_Text": "Our AI matches diners who specifically need your dishes' nutrients to their personalized health plans. These aren't random customers—they're seeking exactly what you already make.",
      "Complete_Section_0": "Complete Section 1: Working with Youtopia"
    },
    "Step_1": {
      "Page_1_Title": "From Idea to Impact",
      "Page_1_Intro": "Every great menu item starts as an idea — a flavor combination, a signature dish, or a twist you know your customers will love. At Youtopia, we help you take that idea and shape it into a meal that reaches more people and more often.",
      "Page_1_List_Intro": "Your Youtopia Journey at a Glance",
      "Page_1_List_Item_1": "Meet the Standards – Align with our clean ingredient guidelines, certify your meals, and present them with consistency and care.",
      "Page_1_List_Item_2": "Create Your Menu Items – Use our nutrient-first builder to design offerings that are purposeful, personalized, and appealing.",
      "Page_1_List_Item_3": "Go Live – Your meals appear in the Youtopia marketplace, matched to the customers who will value them most.",
      "Page_1_List_Item_4": "Accept & Fulfill Orders – Clear, timely orders with packaging tools, labels, and prep guidance built in.",
      "Page_1_List_Item_5": "Get Paid & Grow – Fast payouts, customer reviews, and insights to help you improve and expand.",
      "Page_1_Callout": "When Youtopians browse, they see meals recommended to them based on their health needs. Your certified meals are matched directly to them through our nutrient engine — creating a win-win for your kitchen and your community.",
      "Page_1_Sidebar_Title": "Did you know?",
      "Page_1_Sidebar_Text": "--",
      "Page_2_Title": "Certification & Standards",
      "Page_2_Intro": "Every meal you serve carries your name and reputation. The right ingredients don't just make it taste better — they open doors to new customers who care about quality and trust where their food comes from.",
      "Page_2_Process_Title": "Here's how it works:",
      "Page_2_List_Item_1": "Choose your distributor and download the latest approved buy list",
      "Page_2_List_Item_2": "Want to use something not listed? Upload your buy list — we'll review it and let you know what qualifies",
      "Page_2_List_Item_3": "Ingredients are scored and categorized by nutritional quality and function",
      "Page_2_List_Item_4": "Anything not explicitly approved is considered banned by default",
      "Page_2_Closing": "When your dishes carry the Youtopia Certified mark, they're not just meals — they're proof of care. That trust translates into more loyal customers, higher repeat orders, and a stronger story for your business.",
      "Page_2_Sidebar_Title": "Did you know?",
      "Page_2_Sidebar_Text": "Every certified ingredient becomes part of your \"Youtopia Certified\" story — giving you a built-in marketing edge, access to health-focused customers, and a trust mark you can use on every menu item.",
      "Page_3_Title": "Creating a Menu Item",
      "Page_3_Intro": "Your menu is more than a list of dishes — it's a reflection of your craft, your story, and the people you serve.",
      "Page_3_Process_Title": "Step-by-Step Process",
      "Page_3_Step_1_Title": "Build Your Recipes",
      "Page_3_Step_1_Description": "Start by creating individual recipes for mains, sides, sauces, or toppings — all using approved ingredients.",
      "Page_3_Step_2_Title": "Assemble Your Menu Item",
      "Page_3_Step_2_Description": "Combine recipes into a complete meal. Add components like a main, side, or sauce to build a plate your customers will love.",
      "Page_3_Step_3_Title": "Optimize the Nutrients",
      "Page_3_Step_3_Description": "Our system analyzes your ingredients and portion sizes in real time — helping you adjust for optimal nutrient impact.",
      "Page_3_Step_4_Title": "Define Portion Sizes",
      "Page_3_Step_4_Description": "Offer your meal in XS, S, L and XL — each with its own portion weight, cost, and plating guidance.",
      "Page_3_Step_5_Title": "Finalize Your Listing",
      "Page_3_Step_5_Description": "Add a description, prep instructions, and a photo. Preview how your meal will appear to Youtopians — ready to be matched and served.",
      "Page_3_Closing": "Your recipe joins the Youtopia system for fulfillment and personalization. Youtopia may use and adapt it, and after 2 years, it may be repurposed, shared with other producers, or offered to customers for DIY use.",
      "Page_3_Sidebar_Title": "Exceptional recipes may also be featured in:",
      "Page_3_Sidebar_Item_1": "Marketing campaigns",
      "Page_3_Sidebar_Item_2": "Branded content or cookbooks",
      "Page_3_Sidebar_Item_3": "Customer stories with full credit to the original creator",
      "Page_4_Title": "Presentation & Packaging",
      "Page_4_Intro": "The way a meal looks and travels is just as important as how it tastes — because presentation builds trust, and trust keeps customers coming back.",
      "Page_4_Process_Title": "Here's how it works:",
      "Page_4_Paragraph_1": "Our approved containers and labels aren't just about meeting standards — they're about making sure your meals arrive exactly as you intended.",
      "Page_4_Paragraph_2": "Our approved containers and labels aren't just about meeting standards — they're about making sure your meals arrive exactly as you intended.",
      "Page_4_List_Item_1": "Keeps your craft intact – Maintains taste, texture, and presentation from kitchen to customer, reducing re-makes and complaints.",
      "Page_4_List_Item_2": "Sustainable by default – Packaging designed to reduce waste without compromising quality.",
      "Page_4_List_Item_3": "Built-in convenience – Easily order from trusted partners, and use our labels to ensure every meal is clearly identified.",
      "Page_4_Closing": "Because when your food looks good, stays fresh, and arrives exactly as promised, customers come back — and tell others.",
      "Page_4_Sidebar_Title": "Did you know?",
      "Page_4_Sidebar_Text": "Customers can order meals up to 10 days ahead, and they arrive 1–2 days before eating — locked in for maximum freshness.",
      "Complete_Section_1": "Complete Section 2: Creating a Menu Item"
    },
    "Step_2": {
      "Page_1_Title": "How customers order",
      "Page_1_Intro": "We've run kitchens where a little notice made the whole week easier.",
      "Page_1_Description": "When guests order ahead, you can plan your prep, set your team, and skip the last-minute scramble. That's why Youtopians give their guests three simple ways to order:",
      "Page_1_Options_Title": "Youtopian order options:",
      "Page_1_Schedule_Save": "Schedule Ahead & Save – Guests order up to 10 days in advance, locking in sales and giving you time to source exactly what you need.",
      "Page_1_On_Demand": "On Demand – Orders placed up to 2 days ahead keep your line busy without the scramble.",
      "Page_1_Dine_In": "Dine In – Guests enjoy your food on the spot, with the same nutrient-focused care that keeps them coming back.",
      "Page_1_Closing": "Three options, same goal: steadier days, fuller windows, and guests who keep coming back.",
      "Page_1_Sidebar_Title": "How does pricing work?",
      "Page_1_Sidebar_Text": "You set and control your meal pricing and we'll show it clearly everywhere.\n\nDiscounts are optional, but can help boost volume and smooth the line.",
      "Page_2_Title": "How We Process Orders",
      "Page_2_Intro": "We've stood on the line wondering what's coming in next — it's exhausting.",
      "Page_2_Description": "When orders arrive in the moment, every station feels the pressure. That's why Youtopia meals move through a simple, visible flow — from the guest's choice to your kitchen display — so you can see what's coming and when.",
      "Page_2_Process_Title": "Ordering process",
      "Page_2_Guest_Orders": "Guest orders – Whether it's Schedule Ahead & Save, On Demand, or Dine In, the moment they confirm, it's locked in.",
      "Page_2_Order_Hits_KDS": "Order hits your rail (KDS) – Every item appears on your kitchen display screen with clear timing and pickup windows.",
      "Page_2_Prep_Handoff": "You prep and handoff – Your team works the order into their rhythm, handing it off without slowing the line.",
      "Page_2_Closing": "Every order is in view, every pickup window clear — no more guessing what's next.",
      "Page_2_Sidebar_Title": "Did you know?",
      "Page_2_Sidebar_Text": "--",
      "Page_3_Title": "Our Payment Options",
      "Page_3_Intro": "You shouldn't have to chase down payments or wonder when the next deposit is coming. We've built a payout system that's as predictable as your prep schedule — so you can focus on the food, not the paperwork.",
      "Page_3_Payment_Title": "Here's how we make it simple to get paid:",
      "Page_3_Automatic_Payouts": "Automatic Payouts – Earnings are sent to your account on a reliable schedule, no extra steps required.",
      "Page_3_Transparent_Tracking": "Transparent Tracking – Your Dashboard shows every order, every payout, and every fee — so there are no surprises.",
      "Page_3_Fast_Turnaround": "Fast Turnaround – Most payouts are processed within X business days after a meal is fulfilled, keeping your cash flow steady.",
      "Page_3_Sidebar_Title": "Did you know?",
      "Page_3_Sidebar_Text": "--",
      "Page_4_Title": "How Deliveries are Managed",
      "Page_4_Intro": "You've done the hard part — the last thing you need is to worry about what happens once the food leaves your kitchen.",
      "Page_4_Description": "Our delivery process protects your work from the moment it's picked up to the moment it reaches the customer — keeping meals fresh, on time, and presented the way you intended.",
      "Page_4_Process_Title": "Here's how we handle the handoff:",
      "Page_4_Reliable_Pickup": "Reliable Pickup Windows – Couriers arrive at set times based on order type, so you can plan your kitchen flow without disruption.",
      "Page_4_Temperature_Safe": "Temperature-Safe Transport – All meals travel in insulated, food-safe carriers to lock in freshness and presentation.",
      "Page_4_Status_Tracking": "Status Tracking – Track pickups and deliveries in real time through your Dashboard for peace of mind.",
      "Page_4_Sidebar_Title": "Did you know?",
      "Page_4_Sidebar_Text": "--",
      "Complete_Section_2": "Complete Section 3: Order Management"
    },
    "Step_3": {
      "Page_1_Title": "Recognition for your work",
      "Page_1_Intro": "We know what it's like to work long hours in the kitchen and feel like the only people who notice are the ones behind the line with you.",
      "Page_1_Story": "When we ran our own kitchen, recognition wasn't about awards or fancy write-ups—it was that quiet moment when a customer told us they came back just for our food. That connection is powerful, and we think it should happen more often.",
      "Page_1_Review_Intro": "At Youtopia, guests can review you on the following:",
      "Page_1_Review_Taste": "Taste",
      "Page_1_Review_Presentation": "Presentation",
      "Page_1_Review_Quality": "Overall Quality",
      "Page_1_Review_Frequency": "How often they'd want to enjoy the meal again",
      "Page_1_Visibility": "On Youtopia, you're not hidden behind a brand name or a generic listing. Customers see your face, your dishes, and the story that got you here. We make sure they know who made their meal and why it's special.",
      "Page_2_Title": "Becoming a Successful Healthy Gourmet Kitchen",
      "Page_2_Intro": "Youtopia rewards kitchens who align with customer needs, show up consistently, and deliver meals that make people feel better.",
      "Page_2_Success_Principles": "Success here isn't luck — it's built through a few proven practices.",
      "Page_2_High_Feedback_Title": "Earn High Feedback Scores",
      "Page_2_Feedback_Intro": "Every meal is rated by Youtopians. Strong, consistent ratings mean:",
      "Page_2_Visibility": "More visibility in search and matching",
      "Page_2_Loyalty": "Stronger customer loyalty",
      "Page_2_Repeat_Eaters": "A growing base of repeat eaters",
      "Page_2_Dashboard_Info": "You'll see your feedback directly in your dashboard, along with trends and suggestions to help you improve.",
      "Page_2_Variety_Title": "Offer Variety & Coverage",
      "Page_2_Variety_Intro": "Show up in more searches — and more carts — by:",
      "Page_2_Multiple_Occasions": "Serving meals for multiple occasions (lunch, dinner, etc.)",
      "Page_2_Portion_Sizes": "Offering different portion sizes (XS-XL) to fit nutrient and budget needs",
      "Page_2_Quality_Title": "Maintain Quality Standards",
      "Page_2_Quality_Standards": "We hold all kitchens to ingredient, presentation, and fulfillment standards through:",
      "Page_2_Youtopian_Ratings": "Youtopian Ratings – Direct customer feedback after every meal",
      "Page_2_Spot_Checks": "Spot Checks – Periodic reviews to ensure alignment with agreed-upon standards",
      "Page_2_Quality_Warning": "If consistent issues arise (missed fulfillment, poor presentation, etc.), we'll work with you to resolve them — but continued problems may lead to removal from the platform.",
      "Page_3_Title": "Partnering for Success",
      "Page_3_Partnership_Intro": "Youtopia isn't just a platform — it's a partnership. We're here to help you grow your business, celebrate your craft, and deliver meals that help people feel better through food.",
      "Page_3_Standards_Intro": "Before you start selling, we'll align on the standards that protect your work, keep quality high, and build trust with customers.",
      "Page_3_Legal_Terms_Intro": "You'll find the full legal terms on the next page, but here are the essentials:",
      "Page_3_IP_Acknowledgement": "IP Acknowledgement – We respect your creativity while outlining how recipes and menu items are used within Youtopia.",
      "Page_3_Ingredient_Standards": "Ingredient & Sourcing Standards – Every meal meets our clean, nutrient-first guidelines.",
      "Page_3_Packaging_Standards": "Packaging & Labeling Standards – Meals arrive with consistent, professional presentation that reinforces your brand.",
      "Page_3_Quality_Removal": "Quality & Removal Clause – We set clear expectations for maintaining quality — and outline what happens if standards aren't met.",
      "View_Sign_Agreement": "View and Sign Producer Agreement"
    }
  },
  "Dashboard": {
    "Dashboard": "Dashboard",
    "Title": "Welcome To Youtopia",
    "Subtitle": "Your steps to becoming a Youtopia Healthy Gourmet Kitchen",
    "Description": "Complete the following steps to get your establishment up and running on Youtopia.",
    "Step_1_Title": "Get to know Youtopia",
    "Step_1_Description": "Discover how Youtopia works and how our mission connects with your business.",
    "Step_2_Title": "Creating a Menu Item",
    "Step_2_Description": "Turn your best ideas into certified meals with our nutrient-first builder.",
    "Step_3_Title": "Order Management",
    "Step_3_Description": "See how orders flow through your dashboard, with tools that make fulfillment simple.",
    "Step_4_Title": "Become a Youtopia Healthy Gourmet Kitchen",
    "Step_4_Description": "Finalize your agreement, meet the standards, and unlock access to the marketplace.",
    "Estimated_Time": "EST",
    "Minutes": "Mins"
  },
  "Nutrient_Info": {
    "Essential_Indicator": "indicates essential nutrient",
    "No_Nutrient_Info": "Nutrient Info Unavailable",
    "CalorieContent": "Calorie Content",
    "NetCarbohydratesHeader": "Net Carbohydrates",
    "FiberHeader": "Fiber",
    "SugarHeader": "Sugar",
    "FatsHeader": "Fats",
    "TotalProteinHeader": "Total Protein",
    "VitaminsHeader": "Vitamins",
    "MineralsHeader": "Minerals",
    "HydrationHeader": "Hydration",
    "PhytonutrientsHeader": "Phytonutrients",
    "netCarbohydrates": "Net Carbohydrates",
    "totalFat": "Total Fat",
    "totalProtein": "Total Protein",
    "totalFiber": "Total Fiber",
    "solubleFiber": "Total Soluble Fiber",
    "insolubleFiber": "Total Insoluble Fiber",
    "totalSugar": "Total Sugar",
    "addedSugars": "Total Added Sugar",
    "totalSaturatedFat": "Total Saturated Fat",
    "totalMonounsaturatedFat": "Total Monounsaturated Fat",
    "totalPolyunsaturatedFat": "Total Polyunsaturated Fat",
    "totalTransFat": "Total Trans Fat",
    "linoleicAcidOmega6": "Linoleic Acid (LA) (Omega 6) PUFA",
    "alphaLinoleicAcidOmega3": "Linolenic Acid (ALA) (Omega 3) PUFA",
    "epaDha": "EPA + DHA",
    "histidine": "Histidine",
    "isoleucine": "Isoleucine",
    "leucine": "Leucine",
    "lysine": "Lysine",
    "methionine": "Methionine",
    "phenylalanine": "Phenylalanine",
    "threonine": "Threonine",
    "tryptophan": "Tryptophan",
    "valine": "Valine",
    "vitaminA": "Vitamin A (Retinol)",
    "vitaminB1": "Vitamin B1 (Thiamin)",
    "vitaminB2": "Vitamin B2 (Riboflavin)",
    "vitaminB3": "Vitamin B3 (Niacin)",
    "vitaminB5": "Vitamin B5 (Pantothenic Acid)",
    "vitaminB6": "Vitamin B6 (Pyridoxine)",
    "vitaminB7": "Vitamin B7 (Biotin)",
    "vitaminB9": "Vitamin B9 (Folate)",
    "vitaminB12": "Vitamin B12 (Cyanocbalamin)",
    "vitaminC": "Vitamin C (Ascorbic Acid)",
    "vitaminD3": "Vitamin D3",
    "vitaminE": "Vitamin E (D-Alpha-Tocopherol)",
    "vitaminK": "Vitamin K",
    "chloride": "Chloride",
    "choline": "Choline",
    "calcium": "Calcium",
    "chromium": "Chromium",
    "copper": "Copper",
    "flouride": "Fluoride",
    "iodine": "Iodine",
    "iron": "Iron",
    "magnesium": "Magnesium",
    "manganese": "Manganese",
    "molybedenum": "Molybdenum",
    "phosporus": "Phosphorus",
    "potassium": "Potassium",
    "selenium": "Selenium",
    "sodium": "Sodium",
    "water": "Water",
    "zinc": "Zinc"
  },
  "My_Menu": {
    "Title": "My Menu",
    "Add_Recipe": "Add Recipe",
    "Create_Recipe": "Create Recipe",
    "Add_Consumable": "Add Consumable",
    "Create_Consumable": "Create Consumable",
    "Create_Menu_Item": "Create Menu Item",
    "Menu_Items": "Menu Items",
    "Menu_Item": "Menu Item",
    "Eating_Occasion": "Eating Occasion",
    "Price_Range": "Price Range",
    "Status": "Status",
    "SearchRecipe": "Search Recipe",
    "SearchMenu": "Search Menu Items",
    "Consumables": "Consumables",
    "Recipes": "Recipes",
    "Consumable_Name": "Consumable Name",
    "Classification": "Classification",
    "Sizes": "Sizes",
    "Ideal_Customer": "Ideal Customer",
    "Certified": "Certified",
    "Optimized": "Optimized",
    "Published": "Published",
    "Recipe_Name": "Recipe Name",
    "Category": "Category",
    "Consumables_Number": "Consumables (#)",
    "Approved": "Approved",
    "Recipe_Successfully_Created": "Recipe Successfully Created",
    "Recipe_Successfully_Updated": "Recipe Successfully Updated",
    "Consumable_Successfully_Created": "Consumable Successfully Created",
    "Consumable_Successfully_Updated": "Consumable Successfully Updated",
    "Consumable_Version_Successfully_Created": "Consumable Version Successfully Created",
    "Consumable_Size_Successfully_Created": "Consumable Size Successfully Created",
    "Consumable_Version_Reinstated": "Consumable Version Reinstated",
    "Remove_Temporarily": "Remove Consumable Temporarily",
    "Reactivate": "Reactivate Consumable",
    "Draft": "Draft",
    "Variant": "Variant",
    "On_Menu": "On Menu",
    "Off_Menu": "Off Menu",
    "Rejected": "Rejected",
    "Pending_Approval": "Pending Approval",
    "No_Menu_Item": "You currently do not have any menu items created.",
    "No_Recipe_Item": "You currently do not have any recipes created.",
    "Create_First_Menu_Item": "Create your first menu item",
    "Create_First_Recipe": "Create your first recipe",
    "Create_Variant": "Create Variant",
    "Current_Draft_For": "Current Draft for",
    "One_Variant_For": "1 Variant for",
    "Num_Variants_For": "{{num}} Variants for",
    "Current_Draft_Description": "This draft will update your current menu item after it’s approved and pending orders are finished.",
    "Take_Off_Menu": "Take Off Menu",
    "Return_To_Menu": "Return To Menu",
    "Failed_To_Create_Variant": "Failed to create variant",
    "Failed_To_Toggle_Availability": "We couldn't update this item's menu availability. Please try again.",
    "No_Actions_Available": "No Actions Available"
  },
  "Add_Recipe_Modal": {
    "Edit": "Edit",
    "Done": "Done",
    "New_Recipe": "New Recipe",
    "Recipe_Name": "Recipe Name",
    "Category": "Category",
    "Classification": "Classification",
    "Serving_Size": "Serving Size",
    "Select_Category": "Select Category",
    "Select_Classification": "Select Classification",
    "Select_Serving_Size": "Select Serving Size",
    "Ingredient_Or_Subrecipe": "Ingredient or Subrecipe",
    "Food": "Ingredients",
    "Subrecipe": "Subrecipes",
    "Ingredients": "Ingredients",
    "Subrecipes": "Subrecipes",
    "Quantity": "Quantity",
    "Unit": "Unit",
    "Step": "Step",
    "Describe_Step": "Describe step",
    "Recipe_Info": "Recipe Information",
    "Steps_Info": "Steps Information",
    "Add_Step": "Add Step",
    "Add_Ingredient_Or_Subrecipe": "Add Ingredient or Subrecipe",
    "Select_Ingredient_Or_Subrecipe": "Select Ingredient or Subrecipe",
    "Select_Standards": "Select Ingredient Standard",
    "Standards": "Ingredients Standards",
    "Create_Recipe": "Create Recipe",
    "Create_And_Add_New_Recipe": "Create and add new recipe",
    "No_Results": "No Results",
    "Recipe_Information": "Recipes define how a dish is prepared, like an entrée, bowl, or protein plate, and serve as the operational foundation for what customers see on the menu.",
    "No_Results_Found": "No Results Found",
    "Item_Weight": "Item Weight",
    "Batch_Size_Calculated": "Batch Size Calculated",
    "Serving_Details": "Serving Details",
    "Number_Of_Servings": "Number Of Servings",
    "Tour_Tooltip_1_Title": "Let’s get started!",
    "Tour_Tooltip_1_Description": "First, name your recipe so you can search and find it later. Be as descriptive as you want.",
    "Tour_Tooltip_2_Title": "Select a category",
    "Tour_Tooltip_2_Description": "Select a category for your recipe",
    "Tour_Tooltip_3_Title": "Select a classification",
    "Tour_Tooltip_3_Description": "Select a classification for your recipe",
    "Tour_Tooltip_4_Title": "Add your recipe contents",
    "Tour_Tooltip_4_Description": "Next, add as many ingredients or sub-recipes as needed to build your recipe.",
    "Tour_Tooltip_5_Title": "Final step!",
    "Tour_Tooltip_5_Description": "Once your recipe is complete, select one of the options below to continue!"
  },
  "Edit_Recipe_Modal": {
    "Edit_Recipe": "Edit Recipe",
    "Recipe_Name": "Recipe Name",
    "Category": "Category",
    "Classification": "Classification",
    "Serving_Size": "Serving Size",
    "Select_Category": "Select Category",
    "Select_Classification": "Select Classification",
    "Select_Serving_Size": "Select Serving Size",
    "Ingredient_Or_Subrecipe": "Ingredient or Subrecipe",
    "Select_Standards": "Select Ingredient Standard",
    "Standards": "Ingredients Standards",
    "Food": "Ingredients",
    "Subrecipe": "Subrecipes",
    "Ingredients": "Ingredients",
    "Subrecipes": "Subrecipes",
    "Quantity": "Quantity",
    "Unit": "Unit",
    "Add_Ingredient_Or_Subrecipe": "Add Ingredient or Subrecipe",
    "Select_Ingredient_Or_Subrecipe": "Select Ingredient or Subrecipe",
    "Update_Recipe": "Update Recipe",
    "No_Results": "No Results",
    "No_Results_Found": "No Results Found",
    "Tour_Tooltip_1_Title": "Let’s get started!",
    "Tour_Tooltip_1_Description": "First, name your recipe so you can search and find it later. Be as descriptive as you want.",
    "Tour_Tooltip_2_Title": "Select a category",
    "Tour_Tooltip_2_Description": "Select a category for your recipe",
    "Tour_Tooltip_3_Title": "Select a classification",
    "Tour_Tooltip_3_Description": "Select a classification for your recipe",
    "Tour_Tooltip_4_Title": "Add your recipe contents",
    "Tour_Tooltip_4_Description": "Next, add as many ingredients or sub-recipes as needed to build your recipe.",
    "Tour_Tooltip_5_Title": "Final step!",
    "Tour_Tooltip_5_Description": "Once your recipe is complete, select one of the options below to continue!"
  },
  "Add_Consumable_Modal": {
    "New_Consumable": "New Consumable",
    "Consumable_Details": "Consumable Details",
    "Add_Recipes": "Add Recipes",
    "Create_Recipes": "Create Recipes",
    "Quality_Agreement": "Quality Agreement",
    "Menu_Item_Name": "Menu Item Name",
    "Chef_Name": "Chef Name",
    "Classification": "Classification",
    "Select_Classification": "Select Classification",
    "Description": "Description",
    "Eating_Occasion": "Eating Occasion",
    "Type_Of_Drink": "Type Of Drink",
    "Add_Photo": "Add Photo",
    "Character_Limit": "{{limit}} Character Limit",
    "Create_Consumable": "Create Consumable",
    "Main_Recipe_Title": "Main Recipe",
    "Additional_Recipe_Title": "Additional Recipe",
    "Select_Recipe": "Select Recipe",
    "Add_Recipe": "Add Recipe",
    "Ingredient_Title": "Ingredient",
    "Select_Ingredient": "Select Ingredient",
    "Add_Ingredient": "Add Ingredient",
    "Select_Standards": "Select Ingredient Standard",
    "Standards": "Ingredients Standards",
    "Quantity": "Quantity",
    "Unit": "Unit",
    "Serving_Size": "Serving Size",
    "Select_Serving_Size": "Select Serving Size",
    "Image_Dimensions_Message": "Image dimensions must be between 256 and 1024 pixels wide and tall.",
    "Error_Reading_File": "Error reading file.",
    "Tour_Tooltip_1_Title": "Add recipes",
    "Tour_Tooltip_1_Description": "Search your created recipes to add to consumable",
    "Tour_Tooltip_2_Title": "Add additional ingredients",
    "Tour_Tooltip_2_Description": "Add one-off ingredients that are not a part of your recipes\n\nNote: this will not change your current saved recipes",
    "Name_Not_Unique": "A menu item with this name already exists."
  },
  "Edit_Consumable_Modal": {
    "Edit_Consumable": "Edit Consumable",
    "Consumable_Name": "Consumable Name",
    "Chef_Name": "Chef Name",
    "Classification": "Classification",
    "Select_Classification": "Select Classification",
    "Description": "Description",
    "Add_Photo": "Add Photo",
    "Character_Limit": "{{limit}} Character Limit"
  },
  "Edit_Consumable_Recipes_Modal": {
    "Edit_Consumable": "Edit Consumable",
    "Menu_Item_Name": "Menu Item Name",
    "Main_Recipe_Title": "Main Recipe",
    "Additional_Recipe_Title": "Additional Recipe",
    "Select_Recipe": "Select Recipe",
    "Add_Recipe": "Add Recipe",
    "Ingredient_Title": "Ingredient",
    "Select_Ingredient": "Select Ingredient",
    "Add_Ingredient": "Add Ingredient",
    "Quantity": "Quantity",
    "Unit": "Unit",
    "Recipe_Title": "Recipe Title",
    "Serving_Size": "Serving Size",
    "Select_Serving_Size": "Select Serving Size"
  },
  "Consumable_Wizard": {
    "Name_Your_Menu_Item": "Name your Menu Item",
    "Add_Recipes_Description": "Add recipes, ingredients, sauces, or components to build your consumable.",
    "Consumable_Name": "CONSUMABLE NAME",
    "Name": "Name",
    "Name_Required": "Name is required.",
    "Description": "DESCRIPTION",
    "Internal_Description_Placeholder": "Internal description",
    "Description_Required": "Description is required.",
    "Character_Count": "{{count}}/250",
    "Chef_Name": "Chef Name",
    "Chef_Name_Required": "Chef Name is required.",
    "Category": "CATEGORY",
    "Select_Category": "Select Category",
    "Cuisine_Type": "CUISINE TYPE",
    "Select_Cuisines": "Select Cuisines",
    "Cuisines_Selected": "{0} cuisines selected",
    "Build_Your_Menu_Item": "Build your Menu Item",
    "Build_Description": "Create the core of your meal. Main recipes are the primary dish components—like entrées or protein-focused plates—that define what your meal is all about.",
    "Main": "Main(s)",
    "Side": "Side(s)",
    "Sauce": "Sauce(s)",
    "Additional_Ingredients": "Additional Ingredients",
    "Entree_Parts": {
      "Main": "Main",
      "Side": "Side",
      "Sauce": "Sauce",
      "Additional_Ingredient": "Additional Ingredient"
    },
    "Add_Main_Dish": "+ Add Main Dish",
    "Add_Sides": "+ Add Side(s)",
    "Add_Sauces": "+ Add Sauce(s)",
    "Add_Other": "+ Add Other",
    "Done": "Done",
    "Edit": "Edit",
    "Substitutions_Help": "Have substitutions or modifiers?",
    "Substitutions_Description": "We'll start by creating and optimizing your primary consumable. You can add additional options—like variations or modifiers—later in the process.",
    "Ingredient_Recipe_List": "Ingredient and Recipe List",
    "Create_New_Recipe": "Create new recipe",
    "Search_Recipes_Placeholder": "Search for recipes to add to your meal",
    "Ingredient_Label": "INGREDIENT",
    "Recipe_Label": "RECIPE",
    "No_Results_Found": "No results found",
    "Name_Header": "NAME",
    "Standard_Header": "INGREDIENT STANDARD",
    "Amount_Header": "AMOUNT",
    "Untitled_Recipe": "(Untitled Recipe)",
    "Quantity": "Quantity",
    "Unit": "Unit",
    "Remove": "Remove",
    "About_Consumable": "About your Consumable",
    "About_Description": "View key tags for quality, allergens, and toxins—based on your selected ingredients and recipes.",
    "Quality_Specifications": "Quality Specifications",
    "Allergens_Intolerances": "Allergens/Intolerances",
    "Toxins": "Toxins",
    "None": "None",
    "Optimize_Meal": "Optimize your Meal",
    "Automate_Portions": "Automate your Portions",
    "Modifiers_Substitutions": "Modifiers or Substitutions",
    "Meal_Details": "Meal Details",
    "Publish": "Publish",
    "Back": "Back",
    "Save_Progress": "Save Progress",
    "Next": "Next",
    "Select_Standards": "Select Ingredient Standard",
    "Create_Additional_Sizes": "Create Additional Sizes",
    "Create_Additional_Sizes_Description": "These recommended ingredients can help boost your Nutrient Score and reach more Youtopians. Select the ones you’d like to try in your recipes—mix and match to find the perfect balance of flavor and nutrition.",
    "Calories_Outside_Size_Range": "Calories Outside of Size Range",
    "Pricing_And_Details": "Pricing and Details",
    "Pricing_And_Details_Description": "Tell us how you plan to sell this consumable on Youtopia—we’ll handle the math for you.",
    "Add_Photo": "Add Photo",
    "Image_Required": "Image Required",
    "Marketing_Description_Title": "How would you describe this meal to your customer?",
    "Marketing_Description_Label": "Marketing Description",
    "Marketing_Description_Placeholder": "Marketing description",
    "Eating_Occasion_Title": "When do you plan on selling this?",
    "Eating_Occasion_Required": "Eating Occasion Required",
    "Spice_Level_Title": "How spicy is your consumable?",
    "Spice_Level_Required": "Spice Level Required",
    "Fulfillment_Modality_Title": "How would you like this Menu Item sold?",
    "On_Demand_Label": "Dine In & On Demand",
    "On_Demand_Days_Label": "(Orders within 2-3 days)",
    "Schedule_And_Save_Label": "Schedule Ahead & Save",
    "Schedule_And_Save_Days_Label": "(Orders after 3+ days)",
    "Pricing_Title": "Standard Price for your Menu Item",
    "Pricing_Description": "Set the standard price for each portion size.",
    "Schedule_And_Save_Pricing_Title": "Schedule Ahead & Save Pricing",
    "Schedule_And_Save_Pricing_Description": "Offer customers a discount when they order in advance.",
    "Schedule_And_Save_Floor_Note": "Youtopia buys at a {{floor}}% Schedule Ahead & Save floor — Youtopia's standard cut off retail, the same for every kitchen and not editable. The figures below are your net.",
    "Image_Dimensions_Message": "Image dimensions must be between 256 and 1024 pixels wide and tall.",
    "Error_Reading_File": "Error reading file.",
    "Menu_Item_Size": "Menu Item Size",
    "Standard_Price": "Standard Price",
    "Num_Days_Advance": "{{from}}-{{to}} Days In Advance",
    "Num_Days_Advance_Plus": "{{from}}+ Days In Advance",
    "Discount_Percent": "Discount %",
    "Heating_Instructions": "Heating Instructions",
    "Heating_Instructions_Description": "Set the microwave power level and heating time to ensure your menu item is properly reheated.",
    "Plate_Size": "Plate Size",
    "Select_Plate_Size": "Select Plate Size",
    "Microwave_Power": "Microwave Power",
    "Microwave_Time": "Microwave Time",
    "Standing_Time": "Standing Time",
    "Power": "Power",
    "Min": "Min",
    "Sec": "Sec",
    "Nutrient_Overview_Title": "Nutrient Overview",
    "Nutrient_Overview_Description": "See how your dish aligns with key daily nutrient targets.",
    "Score_Level": "Medium",
    "Optimizing_For": "Optimizing For",
    "Meal_Type": "Meal",
    "Vitamins_Minerals": "Vitamin & Minerals",
    "Protein": "Protein",
    "Fiber": "Fiber",
    "Omega3": "Omega 3s",
    "Energy_Needs": "Required Daily Energy Needs",
    "Nutrients_To_Minimize": "Nutrients to Minimize",
    "Water": "Water",
    "Recommendations_Title": "Recommendations to Optimize your Meal",
    "Recommendations_Description": "These recommended ingredients can help boost your Nutrient Score and reach more Youtopians. Select the ones you'd like to try in your recipes—mix and match to find the perfect balance of flavor and nutrition.",
    "Decrease_Protein": "Decrease your Protein",
    "Protein_High_Message": "Your proteins are currently too high for the medium energy levels which highly impacts your nutrient score.",
    "Add_Vitamins_Minerals": "Add additional Vitamin & Minerals",
    "Add_Fiber": "Add additional Fiber",
    "Try_High_Nutrient_Ingredients": "Try ingredients that are high in this nutrient and see if they match your dish.",
    "Adjust_Portions": "Adjust Portions",
    "See_Recommendations": "See Recommendations",
    "Critical_Daily_Distributed_Essential_Nutrients": "Critical Daily Distributed Essential Nutrients",
    "Recommended_Daily_Essential_Nutrients": "Recommended Daily Essential Nutrients",
    "Search_Ingredients_Recipe": "Search Ingredients or Recipe",
    "Recommendations": "Recommendations",
    "Amount": "Amount",
    "Add": "Add",
    "Choose_Recipe": "Choose Recipe",
    "Select_Demographic": "Select Demographic",
    "Select_Meal": "Select Meal",
    "14_70_Male_Female": "14-70 Male & Female",
    "14_30_Male": "14-30 Male",
    "14_30_Female": "14-30 Female",
    "31_50_Male": "31-50 Male",
    "31_50_Female": "31-50 Female",
    "51_70_Male": "51-70 Male",
    "51_70_Female": "51-70 Female",
    "Breakfast": "Breakfast",
    "Dinner": "Dinner",
    "Lunch": "Lunch",
    "All_Eating_Occasions": "All Eating Occasions",
    "Snack": "Snack",
    "Add_Additional": "Add additional",
    "Recommendation_Optimize": "Recommendation - Optimize",
    "Recommendation_Add_Additional": "Recommendation - Add additional",
    "Vitamins_Minerals_Critical_Description": "These recommended ingredients can help boost your critical vitamin and mineral intake. Select the ones you'd like to try in your recipes—mix and match to find the perfect balance of flavor and nutrition.",
    "Vitamins_Minerals_Recommended_Description": "These recommended ingredients can help boost your overall vitamin and mineral intake to meet daily requirements. Select the ones you'd like to try in your recipes.",
    "Protein_Description": "Your protein intake is at a good level, but could be optimized. Consider these high-quality protein sources to meet your daily requirements.",
    "Fiber_Description": "Increase your fiber intake by adding whole grains, legumes, fruits, or vegetables to help meet your daily fiber goals.",
    "Omega3_Description": "Boost your omega-3 fatty acids with these heart-healthy ingredients that support brain function and reduce inflammation.",
    "Energy_Needs_Description": "Balance your energy intake with these nutrient-dense, energy-providing ingredients to meet your daily caloric needs.",
    "Nutrients_Minimize_Description": "Consider reducing these ingredients or finding healthier alternatives to minimize excess sodium, sugar, and saturated fats.",
    "Water_Description": "Increase hydration with water-rich ingredients and ensure adequate fluid intake throughout the day.",
    "Review_Your_Menu_Item": "Review Your Menu Item",
    "Review_Your_Menu_Item_Description": "Review and finalize all the details of your meal before publishing — from ingredients and pricing to portion sizes and quality standards.",
    "Pricing_And_Availability": "Pricing and Availability",
    "Sold_During": "Sold During",
    "Sizes": "Sizes",
    "Availability": "Availability",
    "Base_Price": "Base Price",
    "Schedule_And_Save_Pricing": "Schedule Ahead & Save Pricing",
    "Microwave_Instructions_Description": "Microwave for {{mMins}} mins {{mSecs}} secs on {{mPower}}, Let sit for {{sMins}} mins",
    "About_Your_Menu_Item": "About Your Menu Item",
    "Spice_Level": "Spice Level",
    "Ingredients": "Ingredients",
    "Menu_Item_Being_Reviewed": "Your Menu Item Is Being Reviewed",
    "Menu_Item_Being_Reviewed_Description": "We’re currently reviewing and processing your Menu Item to make it available to customers.",
    "Menu_Item": "Menu Item",
    "Location": "Location",
    "Contact": "Contact",
    "Add_Another_Menu_Item": "Add Another Menu Item",
    "Want_To_Add_Variations": "Want to add variations to this Menu Item?",
    "Want_To_Add_Variations_Description": "Variations let you offer more choices to customers, like different proteins or portion sizes. You can add them at no extra cost.",
    "Back_To_Home": "Back To Home",
    "Create_A_Variation": "Create A Variation",
    "Portion_Sizes_Title": "Choose Your Portion Sizes",
    "Portion_Sizes_Description": "Select the portion sizes you'd like to offer for this consumable. Each size can be customized with specific nutritional optimization.",
    "Congrats_Message": "Congratulations! You've built your consumable.",
    "Add_Additional_Portions_Question": "Would you like to add additional portion sizes?",
    "Additional_Portion_Sizes": "Additional Portion Sizes",
    "Adding_More_Portions_Description": "Add more portion options to give your customers flexibility in their meal choices.",
    "Ready_To_Submit": "Ready to Submit",
    "Review": "Review",
    "Reviewing_Portion_Context": "Reviewing nutrients for {portionName}",
    "Back_To_Portion_Sizes": "Back to Portion Sizes",
    "Portion_Review_Banner": "You are currently optimizing nutrients for the {portionName} portion size ({calories} kcal)",
    "Review_Portion_Size": "Review your portions for ",
    "Review_Size_Message": "Set the portion size for this meal to match the new serving option. <br/> Once you’ve adjusted it, you can decide whether you want to publish this size or leave it unpublished. <br/>",
    "Review_Size_Message_Cont": "Fine-tuning portions ensures the meal stays balanced and meets your standards across all sizes.",
    "Daily_Amounts_Title": "How many consumables are for sale each day?",
    "Daily_Amounts_Description": "Specify the quantity available for each day of the week",
    "Max_Amount_Per_Day": "Max daily amount",
    "Same_Amount_Per_Day": "Same amount per day",
    "Daily_Amounts_Required": "Please specify at least one day with a quantity greater than 0",
    "Sunday": "SUNDAY",
    "Monday": "MONDAY",
    "Tuesday": "TUESDAY",
    "Wednesday": "WEDNESDAY",
    "Thursday": "THURSDAY",
    "Friday": "FRIDAY",
    "Saturday": "SATURDAY"
  },
  "Draft_Entree": {
    "Getting_Started": "Name and Target Market",
    "Build_Menu_Item": "Build Menu Item",
    "Choose_Sizes": "Choose Sizes",
    "Review_And_Publish": "Review And Publish",
    "Save_Progress": "Save Progress",
    "Saving_Draft": "Saving Draft",
    "Your_Nutrient_Targets": "Your Nutrient Targets",
    "Size": "Size",
    "Choose_A_Nutrient_To_Optimize": "Choose a nutrient to optimize",
    "Critical_Daily_Distributed_Essential_Nutrients": "Critical Daily Distributed Essential Nutrients",
    "Recommended_Daily_Essential_Nutrients": "Recommended Daily Essential Nutrients",
    "Critical_Vitamins_And_Minerals": "Critical Vitamins & Minerals",
    "Protein": "Protein",
    "Fiber": "Fiber",
    "Omegas": "Omegas",
    "Additional_Vitamins_And_Minerals": "Additional Vitamins & Minerals",
    "Required_Daily_Energy_Needs": "Required Daily Energy Needs",
    "Nutrients_To_Minimize": "Nutrients to Minimize",
    "Water": "Water",
    "Choose_Your_Target_Market": "Choose your Target Market",
    "Choose_Your_Target_Market_Description": "This helps us determine how to setup your target nutrients so that you can meet their nutrient needs and preferences.",
    "Target_Market": "Target Market",
    "Eating_Occasion": "Eating Occasion",
    "Name_Your_Menu_Item": "Name Your Menu Item",
    "Name_Your_Menu_Item_Description": "Add recipes, ingredients, sauces, or components to build your consumable.",
    "Menu_Item_Name": "Menu Item Name",
    "Name": "Name",
    "Menu_Item_Name_Required": "Menu Item Name is required.",
    "Menu_Item_Name_Min_Length": "Menu Item Name must be at least 3 characters.",
    "Menu_Item_Name_Max_Length": "Menu Item Name cannot be more than 100 characters.",
    "Menu_Item_Name_Not_Unique": "This name is already in use",
    "Internal_Description": "Internal Description",
    "Description": "Description",
    "Internal_Description_Required": "Internal Description is required.",
    "Internal_Description_Max_Length": "Internal Description cannot be more than 250 characters.",
    "Classification": "Classification",
    "Classification_Required": "Classification is required.",
    "Cuisine": "Cuisine",
    "Cuisine_Type": "Cuisine Type",
    "Cuisine_Type_Required": "Cuisine Type is required.",
    "Choose_A_Component_To_Build": "Choose a Component to Build",
    "Choose_A_Component_To_Build_Description": "Combine Recipes and ingredients to create a complete Menu Item.",
    "Main_s": "Main(s)",
    "Main": "Main",
    "Main_Description": "Choose the primary component of your dish, such as an entrée or protein",
    "Side_s": "Side(s)",
    "Side": "Side",
    "Side_Description": "Choose the primary component of your dish, such as an entrée or protein",
    "Sauce_s": "Sauce(s)",
    "Sauce": "Sauce",
    "Sauce_Description": "Choose the primary component of your dish, such as an entrée or protein",
    "Additional_Ingredients": "Additional Ingredients",
    "Additional_Ingredient": "Additional Ingredient",
    "Additional_Ingredients_Description": "Choose the primary component of your dish, such as an entrée or protein",
    "Finish_Building_Menu_Item": "Finish Building Menu Item",
    "Add_A_Component": "Add a {{component}}",
    "Add_A_Component_Description": "Choose the primary component of your dish, such as an entrée or protein. This forms the core of the Menu Item and guides how it’s prepared and served.",
    "Add_Recipe": "Add Recipe",
    "Add_Ingredient": "Add Ingredient",
    "Create_New_Recipe": "Create New Recipe",
    "Recipe_Search_Placeholder": "Search and add an existing subrecipe",
    "Ingredient_Search_Placeholder": "Search and add an existing ingredient",
    "About_Your_Menu_Item": "About Your Menu Item",
    "About_Your_Menu_Item_Description": "View key tags for quality, allergens, and toxins—based on your selected ingredients and recipes.",
    "Quality_Specifications": "Quality Specifications",
    "Allergens_Intolerances": "Allergens/Intolerances",
    "Toxins": "Toxins",
    "Amount": "Amount",
    "Unit": "Unit",
    "Quantity": "Quantity",
    "Add_Additional_Main": "Add Additional Main",
    "Add_Additional_Side": "Add Additional Side",
    "Add_Additional_Sauce": "Add Additional Sauce",
    "Add_Additional_Ingredient": "Add Additional Ingredient",
    "Nutrient_Detail": "Nutrient Detail",
    "Nutrient_Detail_Placeholder": "Add your recipe and select a nutrient category to view nutrients",
    "Optimization_Suggestions": "Optimization Suggestions",
    "Optimization_Suggestions_Placeholder": "Add your recipe and select a nutrient category to view optimization suggestions",
    "Create_Additional_Sizes": "Create Additional Sizes",
    "Create_Additional_Sizes_Description": "Choose the primary component of your dish, such as an entrée or protein. This forms the core of the Menu Item and guides how it’s prepared and served.",
    "Num_Kilo_Calories": "{{calories}} Kcal",
    "Size_Confirmation_Modal_Title": "Which sizes would you like to add to your menu?",
    "Size_Confirmation_Modal_Description": "The following sizes are available to add as sizes to your menu item. Only menu items above 80% will be eligible.",
    "Your_Sizes": "Your Sizes",
    "Nutrient_Overview": "Nutrient Overview",
    "Pricing_And_Details": "Pricing and Details",
    "Pricing_And_Details_Description": "Tell us how you plan to sell this consumable on Youtopia—we’ll handle the math for you.",
    "Image_Upload_Error": "Error Uploading Image",
    "Photo_Recommended_Size": "Recommended size: 1024 x 1024",
    "Marketing_Description_Title": "How would you describe this meal to your customer?",
    "Marketing_Description": "Marketing Description",
    "Eating_Occasion_Title": "When do you plan on selling this?",
    "Spice_Level_Title": "How spicy is your consumable?",
    "Spice_Level": "Spice Level",
    "Ingredients": "Ingredients",
    "Fulfillment_Modality_Title": "How would you like this Menu Item sold?",
    "On_Demand_Label": "On Demand",
    "On_Demand_Days_Label": "(Orders within 2-3 days)",
    "Schedule_And_Save_Label": "Schedule Ahead & Save",
    "Schedule_And_Save_Days_Label": "(Orders after 3+ days)",
    "Pick_Up_Label": "Pick Up",
    "Establishment_Delivery_Label": "Establishment Delivery",
    "Dine_In_Label": "Dine In",
    "Consumable_Quantity_Title": "How many consumables are for sale each day?",
    "Max_Daily_Amount": "Max Daily Amount",
    "Same_Amount_Per_Day": "Same Amount Per Day",
    "Fulfillment_Modality_Required": "Choose at least one way to sell this menu item.",
    "Schedule_And_Save_Stock_Hint": "A day set to 0 is a day you are closed, so it is not offered for Schedule Ahead & Save.",
    "Schedule_And_Save_Stock_Required": "Enter an amount above 0 for at least one day, or this menu item will never be offered for Schedule Ahead & Save.",
    "Submit_Failed": "We couldn't submit this menu item. Please try again.",
    "Pricing_Title": "Standard Price for your Menu Item",
    "Pricing_Description": "Set the standard price for each portion size.",
    "Schedule_And_Save_Pricing_Title": "Schedule Ahead & Save Pricing",
    "Schedule_And_Save_Pricing_Description": "Offer customers a discount when they order in advance.",
    "Schedule_And_Save_Floor_Note": "Youtopia buys at a {{floor}}% Schedule Ahead & Save floor — Youtopia's standard cut off retail, the same for every kitchen and not editable. The figures below are your net.",
    "Image_Dimensions_Message": "Image dimensions must be between 256 and 1024 pixels wide and tall.",
    "Error_Reading_File": "Error reading file.",
    "Menu_Item_Size": "Menu Item Size",
    "Standard_Price": "Standard Price",
    "On_Demand_Net": "Your On Demand Net",
    "On_Demand_Floor_Note": "Youtopia buys at a {{floor}}% On Demand floor — Youtopia's standard cut off retail, the same for every kitchen and not editable. The net column is yours.",
    "Num_Days_Advance": "{{from}}-{{to}} Days In Advance",
    "Num_Days_Advance_Plus": "{{from}}+ Days In Advance",
    "Percent_Discount": "% Discount",
    "Total_Below_Retail": "Total Below Retail",
    "Advance_Discount_Exceeds_Floor": "An extra discount plus the {{floor}}% Schedule Ahead & Save floor can't be more than 100%. Keep each extra at {{max}}% or less.",
    "Advance_Discount_Whole_Percent": "Enter each extra discount as a whole percent of 0 or more.",
    "Heating_Instructions": "Heating Instructions",
    "Heating_Instructions_Description": "Set the microwave power level and heating time to ensure your menu item is properly reheated.",
    "Plate_Size": "Plate Size",
    "Select_Plate_Size": "Select Plate Size",
    "Microwave": "Microwave",
    "Microwave_Power": "Microwave Power",
    "Microwave_Time": "Microwave Time",
    "Standing_Time": "Standing Time",
    "Power": "Power",
    "Min": "Min",
    "Sec": "Sec",
    "Untitled_Draft": "Untitled Draft",
    "View_Detail": "View Detail",
    "Recipe_Consolidation_Modal_Title": "Save Changes",
    "Save_As_A_New_Recipe": "Save as a New Recipe",
    "Replace_Existing_Recipe": "Replace Existing Recipe",
    "Save_As_A_New_Recipe_Description": "Update the following information to save your optimizations as a new recipe.",
    "Recipe_Information": "Recipe Information",
    "Recipe_Name": "Recipe Name",
    "Category": "Category",
    "Update_Your_Recipe_Instructions": "Update Your Recipe Instructions",
    "Step_Num": "Step {{num}}",
    "Add_Step": "Add Step",
    "Save_As_New_Recipe": "Save as New Recipe",
    "Recipe_Successfully_Created": "Recipe Successfully Created",
    "Review_Your_Menu_Item": "Review Your Menu Item",
    "Review_Your_Menu_Item_Description": "Review and finalize all the details of your meal before publishing — from ingredients and pricing to portion sizes and quality standards.",
    "Pricing_And_Availability": "Pricing and Availability",
    "Sold_During": "Sold During",
    "Sizes": "Sizes",
    "Availability": "Availability",
    "Base_Price": "Base Price",
    "Schedule_And_Save_Pricing": "Schedule Ahead & Save Pricing",
    "Microwave_Instructions": "Microwave for {{mMins}} mins {{mSecs}} secs on {{mPower}}, Let sit for {{sMins}} mins {{sSecs}} secs.",
    "Submit_Menu_Item": "Submit Menu Item",
    "Menu_Item_Being_Reviewed": "Congratulations! Your Menu Item is being reviewed",
    "Menu_Item_Being_Reviewed_Description": "We’re currently reviewing and processing your Menu Item to make it available to customers.",
    "Menu_Item": "Menu Item",
    "Location": "Location",
    "Contact": "Contact",
    "Add_Another_Menu_Item": "Add Another Menu Item",
    "Want_To_Add_Variations": "Want to add variations to this Menu Item?",
    "Want_To_Add_Variations_Description": "Variations let you offer more choices to customers, like different proteins or portion sizes. You can add them at no extra cost.",
    "Back_To_Home": "Back To Home",
    "Create_A_Variation": "Create A Variation",
    "Failed_To_Create_Version": "Failed to create version",
    "Load_Error": "Failed to load this menu item. Refresh the page to try again.",
    "Rejection": "{{name}} Rejected: {{reason}}"
  },
  "Phenotype_Selection_Modal": {
    "Target_Customers": "Target Customers",
    "Gender": "Gender",
    "Age": "Age",
    "Status": "Status"
  },
  "Payment_Modal": {
    "Consumable_Upload": "Consumable Upload",
    "Payment_Details": "Payment Details",
    "Process_Payment": "Process Payment",
    "Payment_Init_Error": "Failed to initialize payment form",
    "States_Init_Error": "Failed to initialize States",
    "Payment_Not_Initialized": "Payment form not initialized",
    "Payment_Processing_Failed": "Payment processing failed",
    "Payment_Success": "Payment processed successfully",
    "Card_Deleted": "Card was successfully removed",
    "Failed_To_Delete_Card": "Card was unsuccessfully removed",
    "Card_Not_Found": "This card is no longer on file for your account. Your saved cards have been refreshed.",
    "Card_Provider_Failed": "Our payment provider couldn't remove this card. Nothing was changed. Please try again.",
    "Card_Removal_Not_Recorded": "The card was removed, but your account didn't finish updating. Please check your default card.",
    "No_Card_Selected": "Select a saved card to remove.",
    "Order_Init_Error": "Failed to initialize order. Please try again.",
    "Invalid_Order": "Invalid order. Please try again.",
    "Enter_Promo": "Enter promo code",
    "Initializing_Payment": "Initializing Payment",
    "Main_Title": "Start Creating. Start Earning.",
    "Main_Subtitle": "A quick payment unlocks access to our chef tools, nutrient optimization, and customer reach.",
    "Have_Promo_Code": "Have a Promo code?",
    "Promo_Section_Subtitle": "Choose the primary component of your dish, such as an entrée or protein",
    "Promo_Code_Label": "PROMO CODE",
    "Enter_Promo_Placeholder": "Enter Promo",
    "Promo_Applied": "Promo code applied successfully",
    "Promo_Removed": "Promo code removed",
    "Promo_Validation_Failed": "Promo code was invalid",
    "Invalid_Promo": "Promo code is invalid",
    "Choose_Payment_Option": "Choose a payment option",
    "Payment_Section_Subtitle": "Choose the primary component of your dish, such as an entrée or protein",
    "Existing_Payment_Method": "Existing Payment Method",
    "New_Payment_Method": "New Payment Method",
    "Select_Saved_Card": "Select a saved card",
    "No_Saved_Payment_Methods": "No saved payment methods found",
    "Loading_Payment_Methods": "Loading payment methods...",
    "Payment_Method": "Payment Method",
    "Name_On_Card": "Name on Card",
    "Full_Name_Placeholder": "Full name",
    "Street_Address": "Street Address",
    "Street_Address_Placeholder": "123 Main St",
    "Apt_Number": "Apt Number",
    "Apt_Number_Placeholder": "Apt, suite, etc. (optional)",
    "City": "City",
    "City_Placeholder": "City",
    "Zip_Code": "Zip Code",
    "Zip_Code_Placeholder": "12345",
    "State": "State",
    "Select_State": "Select State",
    "Phone": "Phone",
    "Phone_Placeholder": "(555) 123-4567",
    "Phone_Number_Error": "Please enter a valid phone number",
    "Save_Credit_Card": "Save this Credit Card",
    "Pay_And_Continue": "Pay & Continue",
    "Order_Summary": "Order Summary",
    "Subtotal": "Subtotal",
    "Promo_Discount": "Promo Discount",
    "Taxes": "Taxes",
    "Total": "Total",
    "Remove_Card": "Remove Card",
    "Delete_Payment": "Delete Payment Method",
    "Delete_Payment_Confirmation": "Are you sure you want to delete this payment method? This action cannot be undone.",
    "Deleting": "Deleting..."
  },
  "Chef_Tool": {
    "Tour_Title": "Welcome to the Chef Tool!",
    "Tour_Description": "Congrats on uploading your first consumable! The Chef tool is where you can utilize all Youtopia has to offer",
    "Tour_Intro_1": "Manage your consumable",
    "Tour_Intro_2": "Optimize your meal for your target market",
    "Tour_Intro_3": "Get your consumable Youtopia certified ",
    "Tour_Intro_4": "Publish and sell your consumable!",
    "Take_A_Tour": "Take a tour",
    "Tour_Tooltip_1_Description": "This top area is where you can view important metrics, optimize and publish your consumable.",
    "Tour_Tooltip_2_Description": "Your details tab is where you can view and manage your consumables recipes. You can also view and manage the consumables public information that your consumers can see.",
    "Tour_Tooltip_3_Description": "The Target Market tab shows how your consumable performs for your top customers. Examine the Nutrient Breakdown to see how you consumable’s nutrients are tracking against the needs of your ideal customers.",
    "Tour_Tooltip_4_Description": "The Optimizer empowers you to make additions to your consumable that will increase the nutrients met for your chosen consumer group. Make sure you create a new version when you’re finished with your additions.",
    "Tour_Tooltip_5_Description": "Sizes is the last stop before publishing! Add more sizes to fit the needs of more customers.",
    "Tour_Tooltip_6_Description": "Versions are where you can see all of your past consumable versions you’ve created.",
    "Tour_Tooltip_7_Description": "When you’re satisfied with your consumable, have optimized to your liking and added all the sizes you need, publish your consumable to make it available to Youtopians!",
    "Skip_Tour_Description": "If you ever have a question or need a quick refresher of how to use the chef tool, visit the help area.",
    "Consumable_Successfully_Updated": "Consumable Successfully Updated",
    "Cert_Pending": "Certification Pending",
    "Cert_Approved": "Certified"
  },
  "Meal_Details": {
    "Consumable_Name": "Consumable Name",
    "Chef_Name": "Chef Name",
    "Classification": "Classification",
    "Eating_Occasion": "Eating Occasion",
    "Description": "Description",
    "Add_Photo": "Add Photo"
  },
  "Meal_Versions": {
    "Previous_Versions": "Previous Versions",
    "Current_Version": "Current Version",
    "Version": "Version",
    "Versions": "Versions",
    "Reinstate_Original": "Reinstate Original",
    "Optimized_For": "Optimized For",
    "Additions": "Additions",
    "Removals": "Removals",
    "Reinstate_Version": "Reinstate Version",
    "Create_New_Consumable": "Create New Consumable"
  },
  "Orders": {
    "Orders": "Orders",
    "Today": "Today",
    "Tomorrow": "Tomorrow",
    "Scheduled": "Scheduled",
    "Ready": "Ready",
    "Completed": "Completed",
    "Declined": "Declined",
    "High": "High",
    "Medium": "Medium",
    "Schedule_Save": "Schedule Ahead & Save",
    "On_Demand": "On Demand",
    "Pickup": "Pickup",
    "Delivery": "Delivery",
    "Low": "Low",
    "Select_Reason_For_Declining": "Select reason for declining",
    "Decline_OutOfStock": "Out of stock",
    "Decline_Capacity": "At capacity",
    "Decline_Equipment": "Equipment issue",
    "Decline": "Decline",
    "Decline_Order": "Decline order",
    "QT": "QT.",
    "QTY": "QTY",
    "SZ": "SZ.",
    "Order": "Order",
    "Order_Confirmed": "Order Confirmed",
    "Order_Declined": "Order Declined",
    "Order_Ready": "Order Marked as Ready",
    "No_Orders": "No orders for",
    "New_Order": "New Order!",
    "No_Orders_Timeframe": "No orders for this timeframe",
    "Pack_On_Day": "Pack {{date}}"
  },
  "Producer_Profile": {
    "Title": "Kitchen Profile",
    "Producer_Profile_Successfully_Updated": "Profile Successfully Updated",
    "Your_Establishment": "Your Establishment",
    "Establishment": "Establishment",
    "Your_Team": "Your Team",
    "Add_Team_Member": "Add Team Member",
    "Head_Chef": "Head Chef",
    "Payment": "Payment",
    "Payout": "Payout",
    "Add_Payment": "Add Payment",
    "Add_Payout": "Add Payout",
    "No_Payment_Method": "You currently don’t have any payment method.",
    "No_Payout_Method": "You currently don’t have any payout method.",
    "Documents_And_Agreements": "Documents And Agreements",
    "View": "View",
    "About": "About",
    "Hours_Of_Operation": "Hours of Operation"
  },
  "Amenities": {
    "Pet_Friendliness": "Pet-Friendliness",
    "Allows_Dogs": "Allows Dogs",
    "Dining_And_Service_Options": "Dining and Service Options",
    "Curbside_Pickup": "Curbside Pickup",
    "Delivery": "Delivery",
    "Dine_In": "Dine-In",
    "Reservations_Accepted": "Reservations Accepted",
    "Take_Out": "Take Out",
    "Outdoor_Seating": "Outdoor Seating",
    "Audience_Suitability": "Audience Suitability",
    "Good_For_Children": "Good for Children",
    "Kids_Menu": "Kids Menu",
    "Good_For_Groups": "Good for Groups",
    "Good_For_Watching_Sports": "Good for Watching Sports",
    "Food_And_Beverage_Offerings": "Food and Beverage Offerings",
    "Serves_Breakfast": "Serves Breakfast",
    "Serves_Brunch": "Serves Brunch",
    "Serves_Lunch": "Serves Lunch",
    "Serves_Dinner": "Serves Dinner",
    "Serves_Wine": "Serves Wine",
    "Serves_Beer": "Serves Beer",
    "Serves_Cocktails": "Serves Cocktails",
    "Serves_Coffee": "Serves Coffee",
    "Serves_Dessert": "Serves Dessert",
    "Serves_Vegetarian_Food": "Serves Vegetarian Food",
    "Entertainment_And_Amenities": "Entertainment and Amenities",
    "Live_Music": "Live Music",
    "Free_Parking_Lot": "Free Parking Lot",
    "Free_Street_Parking": "Free Street Parking",
    "Valet_Parking": "Valet Parking",
    "EV_Charging": "EV Charging",
    "Restrooms": "Restrooms"
  },
  "About_Page": {
    "About": "About",
    "Amenities": "Amenities",
    "Available": "Available",
    "Found_Amenities": "The following amenities have been pulled from Google Places.",
    "Hours_Of_Operation": "Hours of Operation",
    "Found_Hours_Of_Operation": "The following hours of operation have been pulled from Google Places.",
    "Add_Timeslot": "Add Timeslot",
    "Close_Before_Open_Error": "Close time cannot be before open time"
  },
  "Edit_Establishment": {
    "Title": "Edit Establishment",
    "Establishment": "Establishment",
    "Photo_Disclaimer": "Youtopians will be able to see this photo when reviewing your establishment.",
    "Restaurant_Name": "Restaurant Name",
    "Location": "Location",
    "Establishment_Update_Error": "Error Updating Establishment",
    "Establishment_Update_Field_Errors": "Error Updating Establishment. {{errors}}",
    "Field_Error": "{{field}}: {{message}}",
    "Business_Email": "Business Email",
    "Business_Email_Missing": "Your business email is missing. Add it here to save changes to your establishment.",
    "Business_Email_Required": "Business email is required.",
    "Business_Email_Invalid": "Enter a valid email address.",
    "Image_Upload_Error": "Error Uploading Image",
    "Business_Name": "Business Name",
    "Description": "Description",
    "Marketing_Description": "Marketing Description",
    "Website": "Website",
    "Business_Phone": "Business Phone",
    "Fulfullment_Types": "Fulfullment Types",
    "Business_Location": "Business Location",
    "Select_Suggested_Address": "Select an address from the suggestions to save it",
    "No_Results": "No Results",
    "Same_As_Physical_Address": "Same As Physical Address",
    "Mailing_Address": "Mailing Address",
    "Photo_Recommended_Size": "Recommended size: 1024 x 1024"
  },
  "Payment_Methods": {
    "Title": "Payment Methods",
    "Existing_Payment_Method": "Existing Payment Method",
    "New_Payment_Method": "New Payment Method",
    "Choose_Payment_Method": "Choose Payment Method",
    "Create_New_Payment_Method": "Create New Payment Method",
    "Card_Number": "Card Number",
    "MM_YY": "MM/YY",
    "CVV": "CVV",
    "Name_On_Card": "Name On Card",
    "Full_Name_Placeholder": "Full name",
    "Street_Address": "Street Address",
    "Street_Address_Placeholder": "123 Main St",
    "Apt_Number": "Apt Number",
    "Apt_Number_Placeholder": "Apt, suite, etc. (optional)",
    "City": "City",
    "City_Placeholder": "City",
    "Zip_Code": "Zip Code",
    "Zip_Code_Placeholder": "12345",
    "State": "State",
    "Select_State": "Select State",
    "Payment_Not_Initialized": "Payment form not initialized",
    "Payment_Processing_Failed": "Payment processing failed",
    "Payment_Setup_Failed": "Payments Unavailable, please try again",
    "Payment_Success": "Payment processed successfully",
    "Save_Card_Failed": "Failed to save card",
    "Failed_To_Update_Default_Card": "Failed To Update Default Card",
    "Ending_In": "Ending In",
    "Remove": "Remove"
  },
  "Team_Member": {
    "Add_Team_Member": "Add Team Member",
    "Edit_Team_Member": "Edit Team Member",
    "Team_Member": "Team Member",
    "First_Name": "First Name",
    "Last_Name": "Last Name",
    "Phone_Number": "Phone Number",
    "Email": "Email",
    "Business_Role": "Business Role",
    "Create_Team_Member_Error": "Error Creating Team Member"
  },
  "Partner_Onboarding": {
    "Step_1_Title": "Welcome to Youtopia!",
    "Step_1_Label": "Partner",
    "Step_2_Title": "Youtopia Certified Menu Items",
    "Step_2_Label": "Certification",
    "Step_3_Title": "How can I market my items?",
    "Step_3_Label": "Marketing",
    "Step_4_Title": "How does this work with my operation?",
    "Step_4_Label": "Operations",
    "Step_5_Title": "Become a Youtopia Certified Healthy Gourmet Kitchen",
    "Step_5_Label": "Agreement",
    "Finish_Onboarding": "Finish Onboarding"
  },
  "Producer_Details_Modal": {
    "Title": "Kitchen Details",
    "Tax_Id": "Tax ID",
    "Business_License": "Business License",
    "Mailing_Address": "Mailing Address",
    "Food_Safety_Certification": "Food Safety Certification",
    "Terms_Of_Service": "Terms Of Service",
    "Quality_Agreement": "Quality Agreement",
    "Privacy_Policy": "Privacy Policy",
    "End_User_License_Agreement": "End-User License Agreement",
    "License_Number": "License Number",
    "Issuing_Authority_Name": "Issuing Authority Name",
    "Issuing_Authority_City": "Issuing Authority City",
    "Issuing_Authority_County": "Issuing Authority County",
    "Issuing_Authority_State": "Issuing Authority State",
    "Select_State": "Select State",
    "Same_As_Physical_Address": "Same As Physical Address",
    "Issue_Date": "Issue Date",
    "Expiration_Date": "Expiration Date"
  },
  "Optimize_Page": {
    "Select_Target_Market_To_Optimize": "Select a target market to optimize for:",
    "Suggested_Additions": "Suggested Additions",
    "Search_Ingredients_Or_Recipes": "Search ingredients or recipes",
    "Est_Impact": "Est. Impact",
    "No_Optimizations_Found": "No Optimizations Found"
  },
  "Publish_Modal": {
    "Title": "Publish Consumable",
    "Consumable_Sold": "How is this consumable sold?",
    "Consumable_Quantity": "How many consumables are for sale each day?",
    "Apply": "Select all that apply",
    "On_Demand": "On Demand",
    "Schedule_Save": "Schedule Ahead & Save",
    "Max_Amount": "max daily amount",
    "Set_Price": "Set your Base Prices",
    "Same_Amount": "Same amount per day",
    "Discount_Percentage": "% off Base Price",
    "Days_Advance": "days ordered in advance",
    "Spice_Level": "How spicy is this dish?",
    "Select_Cuisine": "Select your cuisine",
    "Cuisine_Type": "Select the Cuisine that best describes your food.",
    "Eating_Occasion": "Eating Occasion",
    "Reheating_Instructions": "Re-Heating Instructions",
    "Select_Plate": "Select Plate Size",
    "Microwave_Instructions": "Microwave Instructions",
    "Place_Contents": "Place all contents with lid on in microwave",
    "Microwave_Power": "Microwave power",
    "Microwave_For": "Microwave for",
    "Let_Stand": "Let stand for",
    "Remove_Careful": "Carefully remove from microwave (plate will be hot)",
    "Enjoy": "Enjoy!",
    "Min": "min",
    "Sec": "sec"
  },
  "Link_Page": {
    "Failed_To_Finalize": "Failed to finalize user registration and creation"
  },
  "Steps": {
    "Availability": "Availability",
    "Price": "Price",
    "Spice_Cuisine": "Spice and Cuisine",
    "Reheating_Instructions": "Reheating Instructions",
    "Confirm_Consumable": "Confirm Details",
    "Quality_Agreement": "Quality Agreement"
  },
  "Microwave_Power_Levels": {
    "High": "High",
    "Medium_High": "Medium-High",
    "Medium": "Medium",
    "Medium_Low": "Medium-Low",
    "Low": "Low"
  },
  "Eating_Occasions": {
    "Breakfast": "Breakfast",
    "Lunch": "Lunch",
    "Dinner": "Dinner"
  },
  "Size": {
    "Extra_Small": "Extra Small",
    "Small": "Small",
    "Medium": "Medium",
    "Large": "Large",
    "Extra_Large": "Extra Large"
  },
  "Size_Abbreviation": {
    "XS": "Extra Small",
    "S": "Small",
    "M": "Medium",
    "L": "Large",
    "XL": "Extra Large"
  },
  "Size_By_SizeId": {
    "1": "Extra Small",
    "2": "Small",
    "3": "Medium",
    "4": "Large",
    "5": "Extra Large"
  },
  "Entree_Parts": {
    "Main": "Main",
    "Side": "Side",
    "Sauce": "Sauce",
    "Additional_Ingredient": "Additional Ingredient"
  },
  "Business_Roles": {
    "Head_Chef": "Head Chef",
    "Sous_Chef": "Sous Chef",
    "Business_Owner": "Business Owner",
    "Other": "Other"
  },
  "Fulfillment_Types": {
    "Dine_In": "Dine-In",
    "TakeOut": "Takeout",
    "Producer_Delivery": "Delivery (In-House)",
    "Youtopia_Delivery": "Delivery (3rd party)",
    "Private_Events_Catering": "Private Events Catering",
    "In_Home_Private_Chef": "In Home Private Chef"
  },
  "Document": {
    "Producer_Agreement": {
      "Title": "Producer Agreement",
      "Description": "Here is a description of this article."
    },
    "Terms_Of_Service": {
      "Title": "Terms Of Service",
      "Description": "Here is a description of this article."
    },
    "Quality_Agreement": {
      "Title": "Quality Agreement",
      "Description": "Here is a description of this article."
    },
    "Privacy_Policy": {
      "Title": "Privacy Policy",
      "Description": "Here is a description of this article."
    },
    "End_User_License_Agreement": {
      "Title": "End-User License Agreement",
      "Description": "Here is a description of this article."
    },
    "Tax_Id_Business_License": {
      "Title": "Tax ID/Business License",
      "Description": "Here is a description of this article."
    },
    "Food_Safety_Certification": {
      "Title": "Food Safety Certification",
      "Description": "Here is a description of this article."
    }
  },
  "Days": {
    "Sunday": "Sunday",
    "Monday": "Monday",
    "Tuesday": "Tuesday",
    "Wednesday": "Wednesday",
    "Thursday": "Thursday",
    "Friday": "Friday",
    "Saturday": "Saturday"
  },
  "Days_Abbreviations": {
    "Sunday": "Sun",
    "Monday": "Mon",
    "Tuesday": "Tues",
    "Wednesday": "Weds",
    "Thursday": "Thurs",
    "Friday": "Fri",
    "Saturday": "Sat"
  }
}
